/* tslint:disable */
/* eslint-disable */
/**
 * PayLogikApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbortMultiPartInvoiceCreationRequest
 */
export interface AbortMultiPartInvoiceCreationRequest {
    /**
     * 
     * @type {number}
     * @memberof AbortMultiPartInvoiceCreationRequest
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AbortMultiPartInvoiceCreationRequest
     */
    'creationId'?: string | null;
}
/**
 * 
 * @export
 * @interface AgedInvoiceSummaryVm
 */
export interface AgedInvoiceSummaryVm {
    /**
     * 
     * @type {string}
     * @memberof AgedInvoiceSummaryVm
     */
    'requestDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgedInvoiceSummaryVm
     */
    'invoices'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgedInvoiceSummaryVm
     */
    'shipments'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgedInvoiceSummaryVm
     */
    'amountDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgedInvoiceSummaryVm
     */
    'currency'?: string | null;
}
/**
 * 
 * @export
 * @interface ApproveInvoicesCarrInvLineVm
 */
export interface ApproveInvoicesCarrInvLineVm {
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillApprNetDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillAuditNetDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillSavings'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillMode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillNetDue'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillRev'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillSelected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'airBillStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'currency'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'lineIdx'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'service'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesCarrInvLineVm
     */
    'modified'?: boolean;
}
/**
 * 
 * @export
 * @interface ApproveInvoicesCarrierVm
 */
export interface ApproveInvoicesCarrierVm {
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrierVm
     */
    'carrierApprNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrierVm
     */
    'carrierAuditNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrierVm
     */
    'carrierSavings'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrierVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesCarrierVm
     */
    'selected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrierVm
     */
    'carrierName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrierVm
     */
    'carrierNetDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrierVm
     */
    'currency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCarrierVm
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCarrierVm
     */
    'invoiceCount'?: number;
    /**
     * 
     * @type {Array<ApproveInvoicesInvoiceVm>}
     * @memberof ApproveInvoicesCarrierVm
     */
    'invoices'?: Array<ApproveInvoicesInvoiceVm> | null;
}
/**
 * 
 * @export
 * @interface ApproveInvoicesCustomerVm
 */
export interface ApproveInvoicesCustomerVm {
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCustomerVm
     */
    'btId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCustomerVm
     */
    'masterBtId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCustomerVm
     */
    'btName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCustomerVm
     */
    'rcvBatchId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCustomerVm
     */
    'rcvBatchDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCustomerVm
     */
    'customerInvoiceNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCustomerVm
     */
    'customerSavings'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCustomerVm
     */
    'customerInvoiceAuditNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCustomerVm
     */
    'customerInvoiceApprNetDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCustomerVm
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesCustomerVm
     */
    'currency'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesCustomerVm
     */
    'selected'?: boolean;
    /**
     * 
     * @type {Array<ApproveInvoicesCarrierVm>}
     * @memberof ApproveInvoicesCustomerVm
     */
    'carrInvoices'?: Array<ApproveInvoicesCarrierVm> | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesCustomerVm
     */
    'invoiceCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesCustomerVm
     */
    'processingApprovedBatch'?: boolean;
}
/**
 * 
 * @export
 * @interface ApproveInvoicesInvoiceDetail
 */
export interface ApproveInvoicesInvoiceDetail {
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'invType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'carrier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'shippedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'deliveredDate'?: string | null;
    /**
     * 
     * @type {PartyVm}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'shipper'?: PartyVm;
    /**
     * 
     * @type {PartyVm}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'consignee'?: PartyVm;
    /**
     * 
     * @type {Array<CarrInvLineMinimalVm>}
     * @memberof ApproveInvoicesInvoiceDetail
     */
    'invoiceCharges'?: Array<CarrInvLineMinimalVm> | null;
}
/**
 * 
 * @export
 * @interface ApproveInvoicesInvoiceVm
 */
export interface ApproveInvoicesInvoiceVm {
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invIdx'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invMode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invoiceApprNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invoiceAuditNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invoiceSavings'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invoiceComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'currency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invoiceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invoiceNetDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'selected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'invType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'isaSenderId'?: string | null;
    /**
     * 
     * @type {Array<ApproveInvoicesCarrInvLineVm>}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'airBills'?: Array<ApproveInvoicesCarrInvLineVm> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesInvoiceVm
     */
    'modified'?: boolean;
}
/**
 * 
 * @export
 * @interface ApproveInvoicesRequestVm
 */
export interface ApproveInvoicesRequestVm {
    /**
     * 
     * @type {InvoiceApprovalOptionsVm}
     * @memberof ApproveInvoicesRequestVm
     */
    'searchOptions'?: InvoiceApprovalOptionsVm;
    /**
     * 
     * @type {Array<ApproveInvoicesCustomerVm>}
     * @memberof ApproveInvoicesRequestVm
     */
    'invoices'?: Array<ApproveInvoicesCustomerVm> | null;
}
/**
 * 
 * @export
 * @interface ApproveInvoicesSearchResponse
 */
export interface ApproveInvoicesSearchResponse {
    /**
     * 
     * @type {Array<ApproveInvoicesCustomerVm>}
     * @memberof ApproveInvoicesSearchResponse
     */
    'invoices'?: Array<ApproveInvoicesCustomerVm> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveInvoicesSearchResponse
     */
    'showApprove'?: boolean;
}
/**
 * 
 * @export
 * @interface ApprovedBatchMinimalVm
 */
export interface ApprovedBatchMinimalVm {
    /**
     * 
     * @type {number}
     * @memberof ApprovedBatchMinimalVm
     */
    'batchId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApprovedBatchMinimalVm
     */
    'approvedDate'?: string;
}
/**
 * 
 * @export
 * @interface AscReferenceCodeVm
 */
export interface AscReferenceCodeVm {
    /**
     * 
     * @type {string}
     * @memberof AscReferenceCodeVm
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AscReferenceCodeVm
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface BasicInfoVm
 */
export interface BasicInfoVm {
    /**
     * 
     * @type {Array<DataPairVm>}
     * @memberof BasicInfoVm
     */
    'invoiceInfo'?: Array<DataPairVm> | null;
    /**
     * 
     * @type {Array<ChargeLineVm>}
     * @memberof BasicInfoVm
     */
    'chargeLines'?: Array<ChargeLineVm> | null;
    /**
     * 
     * @type {string}
     * @memberof BasicInfoVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BasicInfoVm
     */
    'custComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BasicInfoVm
     */
    'auditComment'?: string | null;
    /**
     * 
     * @type {CarrierMinimalVm}
     * @memberof BasicInfoVm
     */
    'carrier'?: CarrierMinimalVm;
    /**
     * 
     * @type {PartyVm}
     * @memberof BasicInfoVm
     */
    'shipper'?: PartyVm;
    /**
     * 
     * @type {PartyVm}
     * @memberof BasicInfoVm
     */
    'consignee'?: PartyVm;
}
/**
 * 
 * @export
 * @interface BasicInfoVmGetResponse
 */
export interface BasicInfoVmGetResponse {
    /**
     * 
     * @type {BasicInfoVm}
     * @memberof BasicInfoVmGetResponse
     */
    'invoice'?: BasicInfoVm;
    /**
     * 
     * @type {boolean}
     * @memberof BasicInfoVmGetResponse
     */
    'requireEditPreAudit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BasicInfoVmGetResponse
     */
    'isWebLocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BasicInfoVmGetResponse
     */
    'showReleaseBtn'?: boolean;
}
/**
 * 
 * @export
 * @interface BillToMinimalVm
 */
export interface BillToMinimalVm {
    /**
     * 
     * @type {string}
     * @memberof BillToMinimalVm
     */
    'btId': string;
    /**
     * 
     * @type {string}
     * @memberof BillToMinimalVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToMinimalVm
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToMinimalVm
     */
    'customerName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToMinimalVm
     */
    'isParent'?: boolean;
}
/**
 * 
 * @export
 * @interface BillToVm
 */
export interface BillToVm {
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'active'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'actualBtid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'address1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'address2'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'attachAutoGen'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'attachAutoProc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'auditChargeStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'auditClassStatus'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'auditMaxCharge'?: number;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'auditMaxClass'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'auditOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'auditVarAllow'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'auditVarStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'autoWithdraw'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'btId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'cmCustId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'comDataCustId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'comments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'contactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'contactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'createdDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'defaultPayDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'defaultPayDaysStart'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'defCarrSvc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'emailFeeInvoice'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'enableIaCustReview'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'enableMatchPayAccessorial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'enableMatchPayLiability'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'enableMatchPayWeight'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'fbogl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'feesInvoiceOnly'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'feesRptBtid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'fundsOffsetDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'glcodingFunction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'importFeeInvoice'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'isParent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'lastExtract'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'lastUsed'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'makeRecFri'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'makeRecMon'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'makeRecSat'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'makeRecSun'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'makeRecThu'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'makeRecTue'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'makeRecWed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'matchPayProgram'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'matchPayWeightFreightClassVariance'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'matchPayWeightTotalVariance'?: number;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'matchTable'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'milesRequired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'phone1Num'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'phone1Type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'phone2Num'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'phone2Type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'postal'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'printFeeInvoice'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'ratingCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillToVm
     */
    'sfrattachments'?: number;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'sfremail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'stateProv'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'synchCibi'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'tandCdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'updatedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'useBenchmarking'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'useCm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'useInvoice'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillToVm
     */
    'usePayToTerms'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BillToVm
     */
    'useSfr'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvCwtVm
 */
export interface CarrInvCwtVm {
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'actualClass'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvCwtVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'cube'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvCwtVm
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'invIdx'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvCwtVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'lineItemSeq'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'pcs'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'ratedAmt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'ratedClass'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvCwtVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvCwtVm
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface CarrInvDatesVm
 */
export interface CarrInvDatesVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'dateQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvDatesVm
     */
    'dateSeq'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvDatesVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvDatesVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'stopDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'stopTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'timeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvDatesVm
     */
    'timeQual'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineMarksVm
 */
export interface CarrInvLineMarksVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'commCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'commCode2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'commCodeQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'commCodeQual2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'compartIdcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'descrip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMarksVm
     */
    'idx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMarksVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMarksVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMarksVm
     */
    'ladingLine'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMarksVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMarksVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'marks'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'marksQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMarksVm
     */
    'marksSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'pkgCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMarksVm
     */
    'recType'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineMeasVm
 */
export interface CarrInvLineMeasVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMeasVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMeasVm
     */
    'industry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMeasVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'length'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'measSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMeasVm
     */
    'measUom'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMeasVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMeasVm
     */
    'width'?: number | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineMinimalVm
 */
export interface CarrInvLineMinimalVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMinimalVm
     */
    'airbillNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMinimalVm
     */
    'apprNetDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMinimalVm
     */
    'auditNet'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMinimalVm
     */
    'custComment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMinimalVm
     */
    'invIdx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMinimalVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMinimalVm
     */
    'lineIdx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMinimalVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMinimalVm
     */
    'mode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineMinimalVm
     */
    'netDue'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvLineMinimalVm
     */
    'selected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineMinimalVm
     */
    'serviceLevel'?: string | null;
    /**
     * 
     * @type {StatusMaster}
     * @memberof CarrInvLineMinimalVm
     */
    'status'?: StatusMaster;
    /**
     * 
     * @type {Array<CarrInvLineRcVm>}
     * @memberof CarrInvLineMinimalVm
     */
    'carrInvLineRc'?: Array<CarrInvLineRcVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineQwVm>}
     * @memberof CarrInvLineMinimalVm
     */
    'carrInvLineQw'?: Array<CarrInvLineQwVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineTariffVm>}
     * @memberof CarrInvLineMinimalVm
     */
    'carrInvLineTariff'?: Array<CarrInvLineTariffVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineMarksVm>}
     * @memberof CarrInvLineMinimalVm
     */
    'carrInvLineMarks'?: Array<CarrInvLineMarksVm> | null;
}
/**
 * 
 * @export
 * @interface CarrInvLinePartyVm
 */
export interface CarrInvLinePartyVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'addr1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'addr2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'addr3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'addr4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'btid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'countrySub'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'entityIdcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'entRelCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'entRelIdcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'idcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'idcodeQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLinePartyVm
     */
    'idx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLinePartyVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLinePartyVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLinePartyVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLinePartyVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'locId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'locQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'name2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'name3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'partyType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'stateProv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'sysLocId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLinePartyVm
     */
    'fpsCustId'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineQwVm
 */
export interface CarrInvLineQwVm {
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'billAsQty'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'billAsQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'dunnageDescr'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'ladingLine'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'ladingQuant'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'pkgFormCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'pkgFormCode2'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'qwSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'svcTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'volQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'volume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'wgtQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'wgtUnitCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'wtKilos'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'wtPounds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineQwVm
     */
    'wtTons'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineQwVm
     */
    'yesNoCode'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineRcVm
 */
export interface CarrInvLineRcVm {
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'advances'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'approvedAmt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'auditedAmt'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'auditMsg'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'billedQty'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'billedQtyQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'bolamt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'bolauditedAmt'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'charge'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'chgMethPay'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'declaredValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'declValQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'entitleCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'freightRate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'ladingLine'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'ladingVal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'ladLiabCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'originalChargeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'originalChargeDescr'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'originAmt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'paidAmt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'pct'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'prepaidAmt'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'rateClassCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'rateCombPointCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'rateQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRcVm
     */
    'rcSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'specChargeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'specChgDescr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'tariffAppCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRcVm
     */
    'totalsColumn'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineRefVm
 */
export interface CarrInvLineRefVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRefVm
     */
    'grpNum'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRefVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRefVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRefVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRefVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'refDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'refDescrip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'refId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'refIdQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRefVm
     */
    'refSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'refTimecode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineRefVm
     */
    'ruleUsed'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'ascCodeDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineRefVm
     */
    'fpsCustId'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineTariffVm
 */
export interface CarrInvLineTariffVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'agencyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'carrSvcLevCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'cityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'commodCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'custSvcLevCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'distQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'dscode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'effectiveDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'exParte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'exParteDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'freightClass'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'intDomCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'ladingLine'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'rateBasisNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'scale'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'shipMop'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'stateProv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'tariffCol'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'tariffDist'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'tariffItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'tariffNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'tariffPart'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'tariffSection'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineTariffVm
     */
    'tariffSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineTariffVm
     */
    'tariffSuppId'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvLineVm
 */
export interface CarrInvLineVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'airbillNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'airbillRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprAccessorial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprAccess'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprBatchId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'apprNet'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditAccess'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditContract'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'auditDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditDiscount'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvLineVm
     */
    'auditFlag'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditNet'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'auditRateIs'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'auditResult'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'auditVariance'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'autoAuditResult'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'bmAccessorial'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'bmDeficit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'bmDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'bmFuel'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'bmGross'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'bmNetDue'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'bundleNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {Array<CarrInvLineMarksVm>}
     * @memberof CarrInvLineVm
     */
    'carrInvLineMarks'?: Array<CarrInvLineMarksVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineMeasVm>}
     * @memberof CarrInvLineVm
     */
    'carrInvLineMeas'?: Array<CarrInvLineMeasVm> | null;
    /**
     * 
     * @type {Array<CarrInvLinePartyVm>}
     * @memberof CarrInvLineVm
     */
    'carrInvLineParty'?: Array<CarrInvLinePartyVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineQwVm>}
     * @memberof CarrInvLineVm
     */
    'carrInvLineQw'?: Array<CarrInvLineQwVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineRcVm>}
     * @memberof CarrInvLineVm
     */
    'carrInvLineRc'?: Array<CarrInvLineRcVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineRefVm>}
     * @memberof CarrInvLineVm
     */
    'carrInvLineRef'?: Array<CarrInvLineRefVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineTariffVm>}
     * @memberof CarrInvLineVm
     */
    'carrInvLineTariff'?: Array<CarrInvLineTariffVm> | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'cashReceiptId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'checkNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'createDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'currAccessorial'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'currAmtDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'currDeficit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'currDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'currFuel'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'currGross'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'custComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'custSvcDescr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'decomment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvLineVm
     */
    'dupeFlag'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'entryTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'equipment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'estDelivDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'estDelivDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evcity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evcountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evdate'?: string;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'evdelayHrs'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'event'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'evfuelGal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evmessage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'evnumCars'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'evnumEmpty'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'evnumLoaded'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evsecSplc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evsplc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evstateProv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evstatReasCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evtime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evtimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'evtotGross'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'evtotLen'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'evtrainDelayReasCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'fundedAmt'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'ibob'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'idx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'lane'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'lastUpdateDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'lastUpdateUser'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'mode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'netDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidAccessorial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidAccess'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'paidNet'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'payBatchId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'payStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'poddate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'podname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'podtime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'podzone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'pudate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'pudateQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'pudelCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'puequipInit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'puequipNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'punumShip'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'purpose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'putime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'rcvBatchId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'reviewStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'serviceLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'shipDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvLineVm
     */
    'svcFail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'termsDescrip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccessorial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum1'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum2'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum3'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum4'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum5'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum6'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum7'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum8'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalAccum9'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totalGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totWgt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totWgtKilos'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totwgtPounds'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'totWgtQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'totWgtTons'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvLineVm
     */
    'verifyNetDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'btId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvLineVm
     */
    'fpsCustId'?: string | null;
    /**
     * 
     * @type {CarrierMinimalVm}
     * @memberof CarrInvLineVm
     */
    'carrier'?: CarrierMinimalVm;
    /**
     * 
     * @type {PartyVm}
     * @memberof CarrInvLineVm
     */
    'shipper'?: PartyVm;
    /**
     * 
     * @type {PartyVm}
     * @memberof CarrInvLineVm
     */
    'consignee'?: PartyVm;
}
/**
 * 
 * @export
 * @interface CarrInvMinimalVm
 */
export interface CarrInvMinimalVm {
    /**
     * 
     * @type {number}
     * @memberof CarrInvMinimalVm
     */
    'apprNetDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvMinimalVm
     */
    'auditNetDue'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'billingCurrency'?: string | null;
    /**
     * 
     * @type {BillToMinimalVm}
     * @memberof CarrInvMinimalVm
     */
    'billTo'?: BillToMinimalVm;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {CarrierMinimalVm}
     * @memberof CarrInvMinimalVm
     */
    'carrier'?: CarrierMinimalVm;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'fpsCustId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvMinimalVm
     */
    'idx'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'invoiceDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'createDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'shipDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'purpose'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvMinimalVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'invType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'isaSenderID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'mode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvMinimalVm
     */
    'netDue'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvMinimalVm
     */
    'selected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'ibob'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvMinimalVm
     */
    'reviewStatus'?: string | null;
    /**
     * 
     * @type {Array<CarrInvLineMinimalVm>}
     * @memberof CarrInvMinimalVm
     */
    'carrInvLine'?: Array<CarrInvLineMinimalVm> | null;
}
/**
 * 
 * @export
 * @interface CarrInvPartyVm
 */
export interface CarrInvPartyVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'addr1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'addr2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'addr3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'addr4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'btId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'countrySub'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'entIdCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'entRelCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'entRelIdCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'idCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'idCodeQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvPartyVm
     */
    'idx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvPartyVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvPartyVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'locId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'locQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'name2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'name3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'partyType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'stateProv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'sysLocId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvPartyVm
     */
    'fpsCustId'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvRefVm
 */
export interface CarrInvRefVm {
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvRefVm
     */
    'grpNum'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvRefVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvRefVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'refDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'refDescrip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'refId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'refIdQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvRefVm
     */
    'refSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'refTimecode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvRefVm
     */
    'ruleUsed'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'fpsCustId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRefVm
     */
    'ascCodeDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvRemarkVm
 */
export interface CarrInvRemarkVm {
    /**
     * 
     * @type {number}
     * @memberof CarrInvRemarkVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvRemarkVm
     */
    'remarkSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvRemarkVm
     */
    'longComment'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrInvVm
 */
export interface CarrInvVm {
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'apprAccess'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'apprBatchId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'apprDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'apprDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'apprFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'apprGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'apprNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditAccess'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditContract'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'auditDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditDiscount'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvVm
     */
    'auditFlag'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditNet'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'auditRateIs'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'auditResult'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'auditVariance'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'autoAuditResult'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'bankAccountNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'bankClientCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'billingContract'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'billingCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'billingDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'biNum'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'bmAccessorial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'bmDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'bmDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'bmFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'bmGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'bmNetDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'calcDueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'calcReqDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'cashReceiptId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'checkNumber'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'ciNum'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'clientBankNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'contactFcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'contactInqRef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'contactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'contactNum1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'contactNum2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'contactNum3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'contactNum4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'correction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'createDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'createUser'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'currAccessorial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'currAmtDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'currDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'currDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'currFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'currGross'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'custComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'custSvcDescr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'dateQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'delDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'deleteDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'deleteUser'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvVm
     */
    'dupeFlag'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'ediCustId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'effectivePayDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'entryTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'equipment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'estDelivDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'estDelivDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'exchRate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'firstBtId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'fpsCarrId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'fpsCustId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'fpsFileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'fundedAmt'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'fundedDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'gsCtlNum'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'gsRecvId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'gsSendId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'gsTrans'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'ibob'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'idCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'idCodeQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'idx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'ieaGrpIncl'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'inFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'invDate2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'invType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaAckReq'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaAuthInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaAuthQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'isaControlNum'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaRecvId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaRecvQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaRepSep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaSecInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaSecInfoQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaSenderId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaSenderIdQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaTestInd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'isaVersionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'lane'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'lastUpdateDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'lastUpdateUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'mode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'netDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'numQual1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'numQual2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'numQual3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'numQual4'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'numShipments'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'paidAccessorial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'paidDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'paidDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'paidFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'paidGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'paidNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'payBatchId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'payCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'payMeth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'payStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'projReqDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'purpose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'ratedCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'rcvBatchDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'rcvBatchId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'reviewStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'scac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'serviceLevel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'seSegIncl'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'shipDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'shipIdNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'shipmentCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'shipMethPay'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'shipperAccount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'shipQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'source'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'stControlNum'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'stTransType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvVm
     */
    'svcFail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'tariffSvcCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'termsBasisDateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsDayOfMon'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsDefAmtDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'termsDefDueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'termsDescrip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsDiscAmt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsDiscDaysDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'termsDiscDueDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsDiscountPct'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsNetDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'termsNetDueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'termsPayMethCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsPct'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'termsPctpayable'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'termsTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'test'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totAdv'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccessorial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum5'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum6'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum7'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum8'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalAccum9'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalDeficit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalFuel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totalGross'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totChg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totDeclVal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'totDeclValQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totFrtRate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'totFrtRateQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totLadQty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totPrepaid'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'totSpecChgCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'totTariffNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totVol'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'totVolUom'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totWgt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totWgtKilos'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totWgtPounds'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'totWgtQual'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'totWgtTons'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'totWgtUom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'transpTermsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'transTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'underCarr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'vdabCarrId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrInvVm
     */
    'verifyNetDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrInvVm
     */
    'wgtUnitCode'?: string | null;
    /**
     * 
     * @type {ApprovedBatchMinimalVm}
     * @memberof CarrInvVm
     */
    'approvedBatch'?: ApprovedBatchMinimalVm;
    /**
     * 
     * @type {CarrierMinimalVm}
     * @memberof CarrInvVm
     */
    'carrier'?: CarrierMinimalVm;
    /**
     * 
     * @type {BillToMinimalVm}
     * @memberof CarrInvVm
     */
    'billTo'?: BillToMinimalVm;
    /**
     * 
     * @type {Array<CarrInvRemarkVm>}
     * @memberof CarrInvVm
     */
    'carrInvRemark'?: Array<CarrInvRemarkVm> | null;
    /**
     * 
     * @type {PartyVm}
     * @memberof CarrInvVm
     */
    'shipper'?: PartyVm;
    /**
     * 
     * @type {PartyVm}
     * @memberof CarrInvVm
     */
    'consignee'?: PartyVm;
    /**
     * 
     * @type {boolean}
     * @memberof CarrInvVm
     */
    'needsEdiInvoice'?: boolean;
    /**
     * 
     * @type {Array<CarrInvRefVm>}
     * @memberof CarrInvVm
     */
    'carrInvRef'?: Array<CarrInvRefVm> | null;
    /**
     * 
     * @type {Array<CarrInvCwtVm>}
     * @memberof CarrInvVm
     */
    'carrInvCwt'?: Array<CarrInvCwtVm> | null;
    /**
     * 
     * @type {Array<CarrInvDatesVm>}
     * @memberof CarrInvVm
     */
    'carrInvDates'?: Array<CarrInvDatesVm> | null;
    /**
     * 
     * @type {Array<CarrInvLineVm>}
     * @memberof CarrInvVm
     */
    'carrInvLine'?: Array<CarrInvLineVm> | null;
    /**
     * 
     * @type {Array<CarrInvPartyVm>}
     * @memberof CarrInvVm
     */
    'carrInvParty'?: Array<CarrInvPartyVm> | null;
    /**
     * 
     * @type {Array<CarrierInvoiceImagesVm>}
     * @memberof CarrInvVm
     */
    'carrInvImages'?: Array<CarrierInvoiceImagesVm> | null;
}
/**
 * 
 * @export
 * @interface CarrierInvoiceImagesVm
 */
export interface CarrierInvoiceImagesVm {
    /**
     * 
     * @type {number}
     * @memberof CarrierInvoiceImagesVm
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrierInvoiceImagesVm
     */
    'carrInvIdx'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CarrierInvoiceImagesVm
     */
    'carrInvLineIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'imageType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'originalFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'imageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    's3Path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'subKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'fileDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'dateLinked'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierInvoiceImagesVm
     */
    'contentType'?: string | null;
}
/**
 * 
 * @export
 * @interface CarrierMinimalVm
 */
export interface CarrierMinimalVm {
    /**
     * 
     * @type {string}
     * @memberof CarrierMinimalVm
     */
    'carrId': string;
    /**
     * 
     * @type {string}
     * @memberof CarrierMinimalVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CarrierMinimalVm
     */
    'scac'?: string | null;
}
/**
 * 
 * @export
 * @interface ChargeLineVm
 */
export interface ChargeLineVm {
    /**
     * 
     * @type {number}
     * @memberof ChargeLineVm
     */
    'displayOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChargeLineVm
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChargeLineVm
     */
    'freight'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargeLineVm
     */
    'deficit'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargeLineVm
     */
    'fuel'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargeLineVm
     */
    'accessorial'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargeLineVm
     */
    'discount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargeLineVm
     */
    'net'?: number;
}
/**
 * 
 * @export
 * @interface CompleteMultiPartInvoiceCreationRequest
 */
export interface CompleteMultiPartInvoiceCreationRequest {
    /**
     * 
     * @type {number}
     * @memberof CompleteMultiPartInvoiceCreationRequest
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompleteMultiPartInvoiceCreationRequest
     */
    'creationId'?: string | null;
    /**
     * 
     * @type {Array<InvoicePartResponse>}
     * @memberof CompleteMultiPartInvoiceCreationRequest
     */
    'completedParts'?: Array<InvoicePartResponse> | null;
}
/**
 * 
 * @export
 * @interface CompleteMultiPartInvoiceCreationResponse
 */
export interface CompleteMultiPartInvoiceCreationResponse {
    /**
     * 
     * @type {number}
     * @memberof CompleteMultiPartInvoiceCreationResponse
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompleteMultiPartInvoiceCreationResponse
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {Array<InvoicePartResponse>}
     * @memberof CompleteMultiPartInvoiceCreationResponse
     */
    'serverTrackedCompletedParts'?: Array<InvoicePartResponse> | null;
}
/**
 * 
 * @export
 * @interface CreateReceivableBatchesForCustomersVm
 */
export interface CreateReceivableBatchesForCustomersVm {
    /**
     * 
     * @type {string}
     * @memberof CreateReceivableBatchesForCustomersVm
     */
    'batchDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReceivableBatchesForCustomersVm
     */
    'customers'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CurrencyVm
 */
export interface CurrencyVm {
    /**
     * 
     * @type {string}
     * @memberof CurrencyVm
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrencyVm
     */
    'display'?: string | null;
}
/**
 * 
 * @export
 * @interface CustPaySetupVm
 */
export interface CustPaySetupVm {
    /**
     * 
     * @type {boolean}
     * @memberof CustPaySetupVm
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustPaySetupVm
     */
    'btId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustPaySetupVm
     */
    'carrId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustPaySetupVm
     */
    'createDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustPaySetupVm
     */
    'createUser'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustPaySetupVm
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustPaySetupVm
     */
    'lastUpdateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustPaySetupVm
     */
    'lastUpdateUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustPaySetupVm
     */
    'mode'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerDataEntryVm
 */
export interface CustomerDataEntryVm {
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'btid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'ascrefCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataEntryVm
     */
    'dispOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'customerDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'allowMulti'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'requiredFieldIndicator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'detailLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'fieldFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'validationTechnique'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataEntryVm
     */
    'tipText'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerReferenceCodeVm
 */
export interface CustomerReferenceCodeVm {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerReferenceCodeVm
     */
    'sortable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerReferenceCodeVm
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceCodeVm
     */
    'customerDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerReferenceCodeVm
     */
    'displayOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceCodeVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {ScreenSize}
     * @memberof CustomerReferenceCodeVm
     */
    'hide'?: ScreenSize;
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceCodeVm
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceCodeVm
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface DataExportsVm
 */
export interface DataExportsVm {
    /**
     * 
     * @type {number}
     * @memberof DataExportsVm
     */
    'id'?: number;
    /**
     * 
     * @type {DateExportStatus}
     * @memberof DataExportsVm
     */
    'statusId'?: DateExportStatus;
    /**
     * 
     * @type {string}
     * @memberof DataExportsVm
     */
    'userJobName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataExportsVm
     */
    's3Bucket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataExportsVm
     */
    's3Key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataExportsVm
     */
    'jobCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataExportsVm
     */
    'jobCompletedDate'?: string | null;
}
/**
 * 
 * @export
 * @interface DataPairVm
 */
export interface DataPairVm {
    /**
     * 
     * @type {string}
     * @memberof DataPairVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataPairVm
     */
    'display'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataPairVm
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DateExportStatus {
    Pending = 'Pending',
    Processing = 'Processing',
    Done = 'Done'
}

/**
 * 
 * @export
 * @interface DateTimeDropdown
 */
export interface DateTimeDropdown {
    /**
     * 
     * @type {string}
     * @memberof DateTimeDropdown
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeDropdown
     */
    'display'?: string | null;
}
/**
 * 
 * @export
 * @interface DateTimeRangeVm
 */
export interface DateTimeRangeVm {
    /**
     * 
     * @type {string}
     * @memberof DateTimeRangeVm
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeRangeVm
     */
    'end'?: string | null;
}
/**
 * 
 * @export
 * @interface DetailedChargeListVm
 */
export interface DetailedChargeListVm {
    /**
     * 
     * @type {Array<DetailedChargeVm>}
     * @memberof DetailedChargeListVm
     */
    'detailedCharges'?: Array<DetailedChargeVm> | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedChargeListVm
     */
    'totalWeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof DetailedChargeListVm
     */
    'totalCharge'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetailedChargeListVm
     */
    'currency'?: string | null;
}
/**
 * 
 * @export
 * @interface DetailedChargeVm
 */
export interface DetailedChargeVm {
    /**
     * 
     * @type {number}
     * @memberof DetailedChargeVm
     */
    'displayOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof DetailedChargeVm
     */
    'pieces'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedChargeVm
     */
    'units'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedChargeVm
     */
    'weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedChargeVm
     */
    'class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedChargeVm
     */
    'itemDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedChargeVm
     */
    'chargeDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedChargeVm
     */
    'chargeAmount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedChargeVm
     */
    'currency'?: string | null;
}
/**
 * 
 * @export
 * @interface DisconnectedCarrInvImagesVm
 */
export interface DisconnectedCarrInvImagesVm {
    /**
     * 
     * @type {number}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'carrierName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'revNum'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'invIdx'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'shipmentNum'?: string | null;
    /**
     * 
     * @type {ImageType}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'imageType'?: ImageType;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'possibly'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'imagePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'imageFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedCarrInvImagesVm
     */
    'dateLinked'?: string;
}
/**
 * 
 * @export
 * @interface EmailVm
 */
export interface EmailVm {
    /**
     * 
     * @type {string}
     * @memberof EmailVm
     */
    'to'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailVm
     */
    'cc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailVm
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailVm
     */
    'body'?: string | null;
}
/**
 * 
 * @export
 * @interface EntryMethodVm
 */
export interface EntryMethodVm {
    /**
     * 
     * @type {string}
     * @memberof EntryMethodVm
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EntryMethodVm
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntryMethodVm
     */
    'selected'?: boolean;
}
/**
 * 
 * @export
 * @interface GLBulkCodingRequest
 */
export interface GLBulkCodingRequest {
    /**
     * 
     * @type {string}
     * @memberof GLBulkCodingRequest
     */
    'btid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GLBulkCodingRequest
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {TargetLevel}
     * @memberof GLBulkCodingRequest
     */
    'level'?: TargetLevel;
    /**
     * 
     * @type {boolean}
     * @memberof GLBulkCodingRequest
     */
    'overwriteExistingGlCodes'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GLBulkCodingRequest
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GLBulkCodingRequest
     */
    'socketId'?: string | null;
}
/**
 * 
 * @export
 * @interface GlCodingRequest
 */
export interface GlCodingRequest {
    /**
     * 
     * @type {boolean}
     * @memberof GlCodingRequest
     */
    'addGlRefRecords'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GlCodingRequest
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {TargetLevel}
     * @memberof GlCodingRequest
     */
    'level'?: TargetLevel;
}
/**
 * 
 * @export
 * @interface HopkinsDepartmentData
 */
export interface HopkinsDepartmentData {
    /**
     * 
     * @type {string}
     * @memberof HopkinsDepartmentData
     */
    'accountNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HopkinsDepartmentData
     */
    'outboundCountry'?: string | null;
}
/**
 * 
 * @export
 * @interface HopkinsDepartmentVm
 */
export interface HopkinsDepartmentVm {
    /**
     * 
     * @type {string}
     * @memberof HopkinsDepartmentVm
     */
    'billToId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HopkinsDepartmentVm
     */
    'departments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HopkinsDepartmentVm
     */
    'comments'?: string | null;
    /**
     * 
     * @type {HopkinsDepartmentData}
     * @memberof HopkinsDepartmentVm
     */
    'additionalData'?: HopkinsDepartmentData;
}
/**
 * 
 * @export
 * @interface ImageListVm
 */
export interface ImageListVm {
    /**
     * 
     * @type {Array<CarrierInvoiceImagesVm>}
     * @memberof ImageListVm
     */
    'images'?: Array<CarrierInvoiceImagesVm> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImageListVm
     */
    'needsEdiInvoice'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ImageType {
    None = 'None',
    AddPage = 'AddPage',
    Bl1 = 'BL_1',
    Bl2 = 'BL_2',
    Bl3 = 'BL_3',
    Bl4 = 'BL_4',
    Bl5 = 'BL_5',
    Bl6 = 'BL_6',
    Bl7 = 'BL_7',
    Bol = 'BOL',
    Cinv = 'CINV',
    Dr1 = 'DR_1',
    Dr2 = 'DR_2',
    Dr3 = 'DR_3',
    EdiInvoice = 'EDIInvoice',
    Images = 'Images',
    Inv = 'INV',
    Invoice = 'Invoice',
    Loa = 'LOA',
    Misc = 'Misc',
    Other = 'OTHER',
    Pod = 'POD'
}

/**
 * 
 * @export
 * @interface InitiateMultiPartInvoiceCreationRequest
 */
export interface InitiateMultiPartInvoiceCreationRequest {
    /**
     * 
     * @type {CarrInvVm}
     * @memberof InitiateMultiPartInvoiceCreationRequest
     */
    'invoice'?: CarrInvVm;
}
/**
 * 
 * @export
 * @interface InitiateMultiPartInvoiceCreationResponse
 */
export interface InitiateMultiPartInvoiceCreationResponse {
    /**
     * 
     * @type {number}
     * @memberof InitiateMultiPartInvoiceCreationResponse
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiateMultiPartInvoiceCreationResponse
     */
    'creationId'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoiceApprovalOptionsVm
 */
export interface InvoiceApprovalOptionsVm {
    /**
     * 
     * @type {Array<BillToMinimalVm>}
     * @memberof InvoiceApprovalOptionsVm
     */
    'billTos'?: Array<BillToMinimalVm> | null;
    /**
     * 
     * @type {Array<CurrencyVm>}
     * @memberof InvoiceApprovalOptionsVm
     */
    'currencies'?: Array<CurrencyVm> | null;
    /**
     * 
     * @type {Array<DateTimeDropdown>}
     * @memberof InvoiceApprovalOptionsVm
     */
    'batchDate'?: Array<DateTimeDropdown> | null;
    /**
     * 
     * @type {BillToMinimalVm}
     * @memberof InvoiceApprovalOptionsVm
     */
    'selectedBillTo'?: BillToMinimalVm;
    /**
     * 
     * @type {CurrencyVm}
     * @memberof InvoiceApprovalOptionsVm
     */
    'selectedCurrency'?: CurrencyVm;
    /**
     * 
     * @type {DateTimeDropdown}
     * @memberof InvoiceApprovalOptionsVm
     */
    'selectedBatchDate'?: DateTimeDropdown;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceApprovalOptionsVm
     */
    'onlyPendingFundsRequests'?: boolean | null;
}
/**
 * 
 * @export
 * @interface InvoiceComment
 */
export interface InvoiceComment {
    /**
     * 
     * @type {string}
     * @memberof InvoiceComment
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoiceCreationStatusRequest
 */
export interface InvoiceCreationStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof InvoiceCreationStatusRequest
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceCreationStatusRequest
     */
    'queueId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceCreationStatusRequest
     */
    'multiPart'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceCreationStatusRequest
     */
    'creationId'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoiceCreationStatusResponse
 */
export interface InvoiceCreationStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof InvoiceCreationStatusResponse
     */
    'queueId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceCreationStatusResponse
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoicePartRequest
 */
export interface InvoicePartRequest {
    /**
     * 
     * @type {number}
     * @memberof InvoicePartRequest
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoicePartRequest
     */
    'creationId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoicePartRequest
     */
    'partNumber'?: number;
    /**
     * 
     * @type {Array<CarrInvLineVm>}
     * @memberof InvoicePartRequest
     */
    'lineItems'?: Array<CarrInvLineVm> | null;
}
/**
 * 
 * @export
 * @interface InvoicePartResponse
 */
export interface InvoicePartResponse {
    /**
     * 
     * @type {string}
     * @memberof InvoicePartResponse
     */
    'tag'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoicePartResponse
     */
    'partNumber'?: number;
}
/**
 * 
 * @export
 * @interface InvoiceResearchListVm
 */
export interface InvoiceResearchListVm {
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVm
     */
    'lineIdx'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'billToName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'carrierName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'carrierNameLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'invoiceNumLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'invoiceReviewStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipmentNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipmentNumLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipmentReviewStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'enteredDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'createDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipDateFormatted'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'purpose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'ibob'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'invType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'invDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'billingDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVm
     */
    'currAmtDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipperName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipperCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipperState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'shipperPostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'consigneeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'consigneeCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'consigneeState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'consigneePostal'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVm
     */
    'totWgtPounds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVm
     */
    'rcvBatchId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'procDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'rcvBatchDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVm
     */
    'paidNetDue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVm
     */
    'checkNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'checkDateFormatted'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'checkDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'payMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'custComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVm
     */
    'isaSenderId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceResearchListVm
     */
    'userSpecificReferences'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface InvoiceResearchListVmPagingResponse
 */
export interface InvoiceResearchListVmPagingResponse {
    /**
     * 
     * @type {Array<InvoiceResearchListVm>}
     * @memberof InvoiceResearchListVmPagingResponse
     */
    'data'?: Array<InvoiceResearchListVm> | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchListVmPagingResponse
     */
    'total'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceResearchListVmPagingResponse
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchListVmPagingResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoiceResearchOptionsVm
 */
export interface InvoiceResearchOptionsVm {
    /**
     * 
     * @type {Array<CarrierMinimalVm>}
     * @memberof InvoiceResearchOptionsVm
     */
    'carriers'?: Array<CarrierMinimalVm> | null;
    /**
     * 
     * @type {Array<BillToMinimalVm>}
     * @memberof InvoiceResearchOptionsVm
     */
    'billTos'?: Array<BillToMinimalVm> | null;
    /**
     * 
     * @type {Array<ModeVm>}
     * @memberof InvoiceResearchOptionsVm
     */
    'mode'?: Array<ModeVm> | null;
    /**
     * 
     * @type {Array<StatusCodeVm>}
     * @memberof InvoiceResearchOptionsVm
     */
    'statusCodes'?: Array<StatusCodeVm> | null;
    /**
     * 
     * @type {Array<AscReferenceCodeVm>}
     * @memberof InvoiceResearchOptionsVm
     */
    'referenceCodes'?: Array<AscReferenceCodeVm> | null;
    /**
     * 
     * @type {Array<EntryMethodVm>}
     * @memberof InvoiceResearchOptionsVm
     */
    'entryMethods'?: Array<EntryMethodVm> | null;
    /**
     * 
     * @type {DateTimeRangeVm}
     * @memberof InvoiceResearchOptionsVm
     */
    'processed'?: DateTimeRangeVm;
    /**
     * 
     * @type {DateTimeRangeVm}
     * @memberof InvoiceResearchOptionsVm
     */
    'checkDate'?: DateTimeRangeVm;
    /**
     * 
     * @type {DateTimeRangeVm}
     * @memberof InvoiceResearchOptionsVm
     */
    'shipped'?: DateTimeRangeVm;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchOptionsVm
     */
    'invoices'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchOptionsVm
     */
    'airBillNums'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchOptionsVm
     */
    'checks'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchOptionsVm
     */
    'findReference'?: string | null;
    /**
     * 
     * @type {PartyVm}
     * @memberof InvoiceResearchOptionsVm
     */
    'shipper'?: PartyVm;
    /**
     * 
     * @type {PartyVm}
     * @memberof InvoiceResearchOptionsVm
     */
    'consignee'?: PartyVm;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResearchOptionsVm
     */
    'sortBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceResearchOptionsVm
     */
    'sortAscending'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchOptionsVm
     */
    'page'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchOptionsVm
     */
    'recordCountRequested'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchOptionsVm
     */
    'requestedRecordCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResearchOptionsVm
     */
    'declaredCount'?: number | null;
}
/**
 * 
 * @export
 * @interface LoginResponseVm
 */
export interface LoginResponseVm {
    /**
     * 
     * @type {string}
     * @memberof LoginResponseVm
     */
    'jwt'?: string | null;
    /**
     * 
     * @type {UserVm}
     * @memberof LoginResponseVm
     */
    'user'?: UserVm;
}
/**
 * 
 * @export
 * @interface LoginVm
 */
export interface LoginVm {
    /**
     * 
     * @type {string}
     * @memberof LoginVm
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginVm
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface ModeVm
 */
export interface ModeVm {
    /**
     * 
     * @type {string}
     * @memberof ModeVm
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ModeVm
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModeVm
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModeVm
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface PartyVm
 */
export interface PartyVm {
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'btId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'name2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'name3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'partyType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'addr1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'addr2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'addr3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'addr4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'stateProv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'countrySub'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyVm
     */
    'fpsCustId'?: string | null;
}
/**
 * 
 * @export
 * @interface QueuedInvoiceCreationResponse
 */
export interface QueuedInvoiceCreationResponse {
    /**
     * 
     * @type {string}
     * @memberof QueuedInvoiceCreationResponse
     */
    'queueId'?: string | null;
}
/**
 * 
 * @export
 * @interface ReferenceListVm
 */
export interface ReferenceListVm {
    /**
     * 
     * @type {Array<UnifiedInvRefVm>}
     * @memberof ReferenceListVm
     */
    'references'?: Array<UnifiedInvRefVm> | null;
    /**
     * 
     * @type {Array<Array<UnifiedInvRefVm>>}
     * @memberof ReferenceListVm
     */
    'accountCodingData'?: Array<Array<UnifiedInvRefVm>> | null;
    /**
     * 
     * @type {Array<Array<UnifiedInvRefVm>>}
     * @memberof ReferenceListVm
     */
    'deletedAccountCodingData'?: Array<Array<UnifiedInvRefVm>> | null;
    /**
     * 
     * @type {Array<UnifiedInvRefVm>}
     * @memberof ReferenceListVm
     */
    'accountCodingHeaders'?: Array<UnifiedInvRefVm> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReferenceListVm
     */
    'showAccountCoding'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferenceListVm
     */
    'showReleaseInvoiceButton'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferenceListVm
     */
    'revReason'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ScreenSize {
    Sm = 'sm',
    Md = 'md',
    Lg = 'lg',
    Xl = 'xl'
}

/**
 * 
 * @export
 * @interface ShipmentCountByStatusVm
 */
export interface ShipmentCountByStatusVm {
    /**
     * 
     * @type {StatusMaster}
     * @memberof ShipmentCountByStatusVm
     */
    'status'?: StatusMaster;
    /**
     * 
     * @type {number}
     * @memberof ShipmentCountByStatusVm
     */
    'invoiceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentCountByStatusVm
     */
    'invoiceAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentCountByStatusVm
     */
    'currency'?: string | null;
}
/**
 * 
 * @export
 * @interface StatusCodeVm
 */
export interface StatusCodeVm {
    /**
     * 
     * @type {string}
     * @memberof StatusCodeVm
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof StatusCodeVm
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface StatusMaster
 */
export interface StatusMaster {
    /**
     * 
     * @type {string}
     * @memberof StatusMaster
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StatusMaster
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StatusMaster
     */
    'statGroup'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StatusMaster
     */
    'sequence'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatusMaster
     */
    'showInWeb'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusMaster
     */
    'showInDashboard'?: boolean;
}
/**
 * 
 * @export
 * @interface StatusMasterVm
 */
export interface StatusMasterVm {
    /**
     * 
     * @type {string}
     * @memberof StatusMasterVm
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StatusMasterVm
     */
    'sequence'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StatusMasterVm
     */
    'statGroup'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatusMasterVm
     */
    'showInWeb'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StatusMasterVm
     */
    'showInDashboard'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatusMasterVm
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatusMasterVm
     */
    'isAuditFailStatus'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TargetLevel {
    All = 'All',
    CarrierInvoice = 'CarrierInvoice',
    CarrierInvoiceLine = 'CarrierInvoiceLine'
}

/**
 * 
 * @export
 * @interface UnifiedInvRefVm
 */
export interface UnifiedInvRefVm {
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'invIdx'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'lineIdx'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'recType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'carrierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'invRev'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'lineSeq'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'refSeq'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'refIdQual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'refId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'refDescrip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'refDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'refTimecode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'ruleUsed'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvRefVm
     */
    'grpNum'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'ascCodeDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedInvRefVm
     */
    'fpsCustId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedInvRefVm
     */
    'modified'?: boolean;
}
/**
 * 
 * @export
 * @interface UserConfigurationVm
 */
export interface UserConfigurationVm {
    /**
     * 
     * @type {Array<CustomerReferenceCodeVm>}
     * @memberof UserConfigurationVm
     */
    'invoiceResearchCustomColumns'?: Array<CustomerReferenceCodeVm> | null;
}
/**
 * 
 * @export
 * @interface UserPermissionVm
 */
export interface UserPermissionVm {
    /**
     * 
     * @type {string}
     * @memberof UserPermissionVm
     */
    'functionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionVm
     */
    'viewOk'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionVm
     */
    'addOk'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionVm
     */
    'editOk'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionVm
     */
    'deleteOk'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionVm
     */
    'exportOk'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionVm
     */
    'logging'?: boolean;
}
/**
 * 
 * @export
 * @interface UserVm
 */
export interface UserVm {
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    'userID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    'email'?: string | null;
    /**
     * 
     * @type {UserConfigurationVm}
     * @memberof UserVm
     */
    'userConfiguration'?: UserConfigurationVm;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserVm
     */
    'allowedBillToIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserVm
     */
    'allowedCarrierIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<UserPermissionVm>}
     * @memberof UserVm
     */
    'permissions'?: Array<UserPermissionVm> | null;
}

/**
 * ApproveInvoicesApi - axios parameter creator
 * @export
 */
export const ApproveInvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
         * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveInvoices: async (approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApproveInvoices/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveInvoicesRequestVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesApprovalPopulationData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApproveInvoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the invoices that need customer approval before paying the carrier.
         * @param {InvoiceApprovalOptionsVm} [invoiceApprovalOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesNeedingApproval: async (invoiceApprovalOptionsVm?: InvoiceApprovalOptionsVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApproveInvoices/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceApprovalOptionsVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the very minimal invoice information for the Approve Invoices Invoice Detail Modal.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimalInvoiceDetail: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMinimalInvoiceDetail', 'id', id)
            const localVarPath = `/api/ApproveInvoices/invoicedetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
         * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCurrentInvoiceState: async (approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApproveInvoices/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveInvoicesRequestVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApproveInvoicesApi - functional programming interface
 * @export
 */
export const ApproveInvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApproveInvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
         * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveInvoices(approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApproveInvoicesSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveInvoices(approveInvoicesRequestVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicesApprovalPopulationData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceApprovalOptionsVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicesApprovalPopulationData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the invoices that need customer approval before paying the carrier.
         * @param {InvoiceApprovalOptionsVm} [invoiceApprovalOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicesNeedingApproval(invoiceApprovalOptionsVm?: InvoiceApprovalOptionsVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApproveInvoicesSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicesNeedingApproval(invoiceApprovalOptionsVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the very minimal invoice information for the Approve Invoices Invoice Detail Modal.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinimalInvoiceDetail(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApproveInvoicesInvoiceDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinimalInvoiceDetail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
         * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCurrentInvoiceState(approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApproveInvoicesSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCurrentInvoiceState(approveInvoicesRequestVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApproveInvoicesApi - factory interface
 * @export
 */
export const ApproveInvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApproveInvoicesApiFp(configuration)
    return {
        /**
         * 
         * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
         * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveInvoices(approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options?: any): AxiosPromise<ApproveInvoicesSearchResponse> {
            return localVarFp.approveInvoices(approveInvoicesRequestVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesApprovalPopulationData(options?: any): AxiosPromise<InvoiceApprovalOptionsVm> {
            return localVarFp.getInvoicesApprovalPopulationData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the invoices that need customer approval before paying the carrier.
         * @param {InvoiceApprovalOptionsVm} [invoiceApprovalOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesNeedingApproval(invoiceApprovalOptionsVm?: InvoiceApprovalOptionsVm, options?: any): AxiosPromise<ApproveInvoicesSearchResponse> {
            return localVarFp.getInvoicesNeedingApproval(invoiceApprovalOptionsVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the very minimal invoice information for the Approve Invoices Invoice Detail Modal.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimalInvoiceDetail(id: number, options?: any): AxiosPromise<ApproveInvoicesInvoiceDetail> {
            return localVarFp.getMinimalInvoiceDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
         * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCurrentInvoiceState(approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options?: any): AxiosPromise<ApproveInvoicesSearchResponse> {
            return localVarFp.saveCurrentInvoiceState(approveInvoicesRequestVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApproveInvoicesApi - object-oriented interface
 * @export
 * @class ApproveInvoicesApi
 * @extends {BaseAPI}
 */
export class ApproveInvoicesApi extends BaseAPI {
    /**
     * 
     * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
     * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApproveInvoicesApi
     */
    public approveInvoices(approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options?: AxiosRequestConfig) {
        return ApproveInvoicesApiFp(this.configuration).approveInvoices(approveInvoicesRequestVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApproveInvoicesApi
     */
    public getInvoicesApprovalPopulationData(options?: AxiosRequestConfig) {
        return ApproveInvoicesApiFp(this.configuration).getInvoicesApprovalPopulationData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the invoices that need customer approval before paying the carrier.
     * @param {InvoiceApprovalOptionsVm} [invoiceApprovalOptionsVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApproveInvoicesApi
     */
    public getInvoicesNeedingApproval(invoiceApprovalOptionsVm?: InvoiceApprovalOptionsVm, options?: AxiosRequestConfig) {
        return ApproveInvoicesApiFp(this.configuration).getInvoicesNeedingApproval(invoiceApprovalOptionsVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the very minimal invoice information for the Approve Invoices Invoice Detail Modal.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApproveInvoicesApi
     */
    public getMinimalInvoiceDetail(id: number, options?: AxiosRequestConfig) {
        return ApproveInvoicesApiFp(this.configuration).getMinimalInvoiceDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submits invoices for approval processing.  Processing is handled by a processing queue
     * @param {ApproveInvoicesRequestVm} [approveInvoicesRequestVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApproveInvoicesApi
     */
    public saveCurrentInvoiceState(approveInvoicesRequestVm?: ApproveInvoicesRequestVm, options?: AxiosRequestConfig) {
        return ApproveInvoicesApiFp(this.configuration).saveCurrentInvoiceState(approveInvoicesRequestVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the User and permissions for the current token authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/getmyuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a JWT to use for authentication for the session.
         * @param {LoginVm} [loginVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginVm?: LoginVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a JWT to use for authentication for the session.
         * @param {LoginVm} [loginVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPermissions: async (loginVm?: LoginVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/withpermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWithPermissions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/withpermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the User and permissions for the current token authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logOut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logOut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generates a JWT to use for authentication for the session.
         * @param {LoginVm} [loginVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginVm?: LoginVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generates a JWT to use for authentication for the session.
         * @param {LoginVm} [loginVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithPermissions(loginVm?: LoginVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithPermissions(loginVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshWithPermissions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshWithPermissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the User and permissions for the current token authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUser(options?: any): AxiosPromise<UserVm> {
            return localVarFp.getMyUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOut(options?: any): AxiosPromise<void> {
            return localVarFp.logOut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates a JWT to use for authentication for the session.
         * @param {LoginVm} [loginVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginVm?: LoginVm, options?: any): AxiosPromise<string> {
            return localVarFp.login(loginVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates a JWT to use for authentication for the session.
         * @param {LoginVm} [loginVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPermissions(loginVm?: LoginVm, options?: any): AxiosPromise<LoginResponseVm> {
            return localVarFp.loginWithPermissions(loginVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options?: any): AxiosPromise<string> {
            return localVarFp.refreshToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWithPermissions(options?: any): AxiosPromise<LoginResponseVm> {
            return localVarFp.refreshWithPermissions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Returns the User and permissions for the current token authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getMyUser(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getMyUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logOut(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logOut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates a JWT to use for authentication for the session.
     * @param {LoginVm} [loginVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(loginVm?: LoginVm, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(loginVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates a JWT to use for authentication for the session.
     * @param {LoginVm} [loginVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithPermissions(loginVm?: LoginVm, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithPermissions(loginVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public refreshToken(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public refreshWithPermissions(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshWithPermissions(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BillToApi - axios parameter creator
 * @export
 */
export const BillToApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all the BillTos the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBillTo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/BillTo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Bill To Id is a string but at current all are numeric
         * @summary Get a specific BillTo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillToById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillToById', 'id', id)
            const localVarPath = `/api/BillTo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Bill To Id is a string but at current all are numeric
         * @summary Get a specific BillTo
         * @param {string} id 
         * @param {string} carrierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataEntryAscRefCodes: async (id: string, carrierId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDataEntryAscRefCodes', 'id', id)
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('getDataEntryAscRefCodes', 'carrierId', carrierId)
            const localVarPath = `/api/BillTo/{id}/DataEntryAscRefCodes/{carrierId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillToApi - functional programming interface
 * @export
 */
export const BillToApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillToApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all the BillTos the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBillTo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillToVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBillTo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The Bill To Id is a string but at current all are numeric
         * @summary Get a specific BillTo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillToById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillToVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillToById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The Bill To Id is a string but at current all are numeric
         * @summary Get a specific BillTo
         * @param {string} id 
         * @param {string} carrierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataEntryAscRefCodes(id: string, carrierId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerDataEntryVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataEntryAscRefCodes(id, carrierId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BillToApi - factory interface
 * @export
 */
export const BillToApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillToApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all the BillTos the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBillTo(options?: any): AxiosPromise<Array<BillToVm>> {
            return localVarFp.getAllBillTo(options).then((request) => request(axios, basePath));
        },
        /**
         * The Bill To Id is a string but at current all are numeric
         * @summary Get a specific BillTo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillToById(id: string, options?: any): AxiosPromise<BillToVm> {
            return localVarFp.getBillToById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The Bill To Id is a string but at current all are numeric
         * @summary Get a specific BillTo
         * @param {string} id 
         * @param {string} carrierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataEntryAscRefCodes(id: string, carrierId: string, options?: any): AxiosPromise<Array<CustomerDataEntryVm>> {
            return localVarFp.getDataEntryAscRefCodes(id, carrierId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillToApi - object-oriented interface
 * @export
 * @class BillToApi
 * @extends {BaseAPI}
 */
export class BillToApi extends BaseAPI {
    /**
     * 
     * @summary Gets all the BillTos the user has access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillToApi
     */
    public getAllBillTo(options?: AxiosRequestConfig) {
        return BillToApiFp(this.configuration).getAllBillTo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Bill To Id is a string but at current all are numeric
     * @summary Get a specific BillTo
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillToApi
     */
    public getBillToById(id: string, options?: AxiosRequestConfig) {
        return BillToApiFp(this.configuration).getBillToById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Bill To Id is a string but at current all are numeric
     * @summary Get a specific BillTo
     * @param {string} id 
     * @param {string} carrierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillToApi
     */
    public getDataEntryAscRefCodes(id: string, carrierId: string, options?: AxiosRequestConfig) {
        return BillToApiFp(this.configuration).getDataEntryAscRefCodes(id, carrierId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CarrInvApi - axios parameter creator
 * @export
 */
export const CarrInvApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AbortMultiPartInvoiceCreationRequest} [abortMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMultiPartInvoiceCreation: async (abortMultiPartInvoiceCreationRequest?: AbortMultiPartInvoiceCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CarrInv/AbortMultiPartInvoiceCreation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(abortMultiPartInvoiceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds an image to the Carrier Invoice
         * @param {number} id 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addImage: async (id: number, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addImage', 'id', id)
            const localVarPath = `/api/CarrInv/{id}/Images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carrierInvoiceImagesVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvoiceCreationStatusRequest} [invoiceCreationStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCarrInvCheckQueuedInvoiceCreationStatePost: async (invoiceCreationStatusRequest?: InvoiceCreationStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CarrInv/CheckQueuedInvoiceCreationState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceCreationStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCarrInvIdReAuditQueuedPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCarrInvIdReAuditQueuedPost', 'id', id)
            const localVarPath = `/api/CarrInv/{id}/ReAudit/Queued`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrInvDisconnectImage: async (id: number, imageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('carrInvDisconnectImage', 'id', id)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('carrInvDisconnectImage', 'imageId', imageId)
            const localVarPath = `/api/CarrInv/{id}/Images/{imageId}/Disconnect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteMultiPartInvoiceCreationRequest} [completeMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMultiPartInvoiceCreation: async (completeMultiPartInvoiceCreationRequest?: CompleteMultiPartInvoiceCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CarrInv/CompleteMultiPartInvoiceCreation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeMultiPartInvoiceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new Carrier Invoice
         * @param {CarrInvVm} [carrInvVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (carrInvVm?: CarrInvVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CarrInv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carrInvVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new Billing invoice for the base invoice
         * @param {number} id 
         * @param {boolean} [handledInvoiceException] 
         * @param {boolean} [createPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingInvoice: async (id: number, handledInvoiceException?: boolean, createPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createBillingInvoice', 'id', id)
            const localVarPath = `/api/CarrInv/{id}/CreateBillingInvoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (handledInvoiceException !== undefined) {
                localVarQueryParameter['handledInvoiceException'] = handledInvoiceException;
            }

            if (createPdf !== undefined) {
                localVarQueryParameter['createPdf'] = createPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new Billing invoice for the base invoice
         * @param {number} id 
         * @param {boolean} [handledInvoiceException] 
         * @param {boolean} [createPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingInvoiceQueued: async (id: number, handledInvoiceException?: boolean, createPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createBillingInvoiceQueued', 'id', id)
            const localVarPath = `/api/CarrInv/{id}/CreateBillingInvoice/queued`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (handledInvoiceException !== undefined) {
                localVarQueryParameter['handledInvoiceException'] = handledInvoiceException;
            }

            if (createPdf !== undefined) {
                localVarQueryParameter['createPdf'] = createPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create the PDF invoice image for the requested invoice
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPdfInvoice: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPdfInvoice', 'id', id)
            const localVarPath = `/api/CarrInv/{id}/CreatePdfInvoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPdfInvoiceQueued: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPdfInvoiceQueued', 'id', id)
            const localVarPath = `/api/CarrInv/{id}/CreatePdfInvoice/queued`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a request to the queue to create a new invoice.  The web request will return immediately and the crete will be queued and processed out of band.
         * @param {CarrInvVm} [carrInvVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueued: async (carrInvVm?: CarrInvVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CarrInv/queued`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carrInvVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the Carrier Invoice for the Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierInvoiceById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCarrierInvoiceById', 'id', id)
            const localVarPath = `/api/CarrInv/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageWithData: async (id: number, imageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImageWithData', 'id', id)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('getImageWithData', 'imageId', imageId)
            const localVarPath = `/api/CarrInv/{id}/Images/{imageId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {string} imageId 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageWithDataFromObject: async (id: number, imageId: string, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImageWithDataFromObject', 'id', id)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('getImageWithDataFromObject', 'imageId', imageId)
            const localVarPath = `/api/CarrInv/{id}/Images/{imageId}/obj`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carrierInvoiceImagesVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all the images associated with an invoice with out the byte arrays
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesForInvoice: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImagesForInvoice', 'id', id)
            const localVarPath = `/api/CarrInv/{id}/Images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This is meant for large statement / parcel invoices that have over 20 line items.
         * @param {InitiateMultiPartInvoiceCreationRequest} [initiateMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateMultiPartInvoiceCreation: async (initiateMultiPartInvoiceCreationRequest?: InitiateMultiPartInvoiceCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CarrInv/InitiateMultiPartInvoiceCreation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateMultiPartInvoiceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvoicePartRequest} [invoicePartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiPartInvoiceCreation: async (invoicePartRequest?: InvoicePartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CarrInv/MultiPartInvoiceCreation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoicePartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarrInvApi - functional programming interface
 * @export
 */
export const CarrInvApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarrInvApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AbortMultiPartInvoiceCreationRequest} [abortMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async abortMultiPartInvoiceCreation(abortMultiPartInvoiceCreationRequest?: AbortMultiPartInvoiceCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.abortMultiPartInvoiceCreation(abortMultiPartInvoiceCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds an image to the Carrier Invoice
         * @param {number} id 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addImage(id: number, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierInvoiceImagesVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addImage(id, carrierInvoiceImagesVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InvoiceCreationStatusRequest} [invoiceCreationStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCarrInvCheckQueuedInvoiceCreationStatePost(invoiceCreationStatusRequest?: InvoiceCreationStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceCreationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCarrInvCheckQueuedInvoiceCreationStatePost(invoiceCreationStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCarrInvIdReAuditQueuedPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCarrInvIdReAuditQueuedPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrInvDisconnectImage(id: number, imageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrInvDisconnectImage(id, imageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteMultiPartInvoiceCreationRequest} [completeMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeMultiPartInvoiceCreation(completeMultiPartInvoiceCreationRequest?: CompleteMultiPartInvoiceCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteMultiPartInvoiceCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeMultiPartInvoiceCreation(completeMultiPartInvoiceCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new Carrier Invoice
         * @param {CarrInvVm} [carrInvVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(carrInvVm?: CarrInvVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrInvMinimalVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(carrInvVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new Billing invoice for the base invoice
         * @param {number} id 
         * @param {boolean} [handledInvoiceException] 
         * @param {boolean} [createPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBillingInvoice(id: number, handledInvoiceException?: boolean, createPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrInvVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBillingInvoice(id, handledInvoiceException, createPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new Billing invoice for the base invoice
         * @param {number} id 
         * @param {boolean} [handledInvoiceException] 
         * @param {boolean} [createPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBillingInvoiceQueued(id: number, handledInvoiceException?: boolean, createPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrInvVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBillingInvoiceQueued(id, handledInvoiceException, createPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create the PDF invoice image for the requested invoice
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPdfInvoice(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPdfInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPdfInvoiceQueued(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPdfInvoiceQueued(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a request to the queue to create a new invoice.  The web request will return immediately and the crete will be queued and processed out of band.
         * @param {CarrInvVm} [carrInvVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQueued(carrInvVm?: CarrInvVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueuedInvoiceCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQueued(carrInvVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the Carrier Invoice for the Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarrierInvoiceById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrInvVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierInvoiceById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageWithData(id: number, imageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierInvoiceImagesVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageWithData(id, imageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {string} imageId 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageWithDataFromObject(id: number, imageId: string, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierInvoiceImagesVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageWithDataFromObject(id, imageId, carrierInvoiceImagesVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all the images associated with an invoice with out the byte arrays
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImagesForInvoice(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierInvoiceImagesVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImagesForInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This is meant for large statement / parcel invoices that have over 20 line items.
         * @param {InitiateMultiPartInvoiceCreationRequest} [initiateMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateMultiPartInvoiceCreation(initiateMultiPartInvoiceCreationRequest?: InitiateMultiPartInvoiceCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitiateMultiPartInvoiceCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateMultiPartInvoiceCreation(initiateMultiPartInvoiceCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InvoicePartRequest} [invoicePartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async multiPartInvoiceCreation(invoicePartRequest?: InvoicePartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicePartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.multiPartInvoiceCreation(invoicePartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CarrInvApi - factory interface
 * @export
 */
export const CarrInvApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarrInvApiFp(configuration)
    return {
        /**
         * 
         * @param {AbortMultiPartInvoiceCreationRequest} [abortMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMultiPartInvoiceCreation(abortMultiPartInvoiceCreationRequest?: AbortMultiPartInvoiceCreationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.abortMultiPartInvoiceCreation(abortMultiPartInvoiceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds an image to the Carrier Invoice
         * @param {number} id 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addImage(id: number, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: any): AxiosPromise<CarrierInvoiceImagesVm> {
            return localVarFp.addImage(id, carrierInvoiceImagesVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceCreationStatusRequest} [invoiceCreationStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCarrInvCheckQueuedInvoiceCreationStatePost(invoiceCreationStatusRequest?: InvoiceCreationStatusRequest, options?: any): AxiosPromise<InvoiceCreationStatusResponse> {
            return localVarFp.apiCarrInvCheckQueuedInvoiceCreationStatePost(invoiceCreationStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCarrInvIdReAuditQueuedPost(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCarrInvIdReAuditQueuedPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrInvDisconnectImage(id: number, imageId: number, options?: any): AxiosPromise<void> {
            return localVarFp.carrInvDisconnectImage(id, imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteMultiPartInvoiceCreationRequest} [completeMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMultiPartInvoiceCreation(completeMultiPartInvoiceCreationRequest?: CompleteMultiPartInvoiceCreationRequest, options?: any): AxiosPromise<CompleteMultiPartInvoiceCreationResponse> {
            return localVarFp.completeMultiPartInvoiceCreation(completeMultiPartInvoiceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new Carrier Invoice
         * @param {CarrInvVm} [carrInvVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(carrInvVm?: CarrInvVm, options?: any): AxiosPromise<CarrInvMinimalVm> {
            return localVarFp.create(carrInvVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new Billing invoice for the base invoice
         * @param {number} id 
         * @param {boolean} [handledInvoiceException] 
         * @param {boolean} [createPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingInvoice(id: number, handledInvoiceException?: boolean, createPdf?: boolean, options?: any): AxiosPromise<CarrInvVm> {
            return localVarFp.createBillingInvoice(id, handledInvoiceException, createPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new Billing invoice for the base invoice
         * @param {number} id 
         * @param {boolean} [handledInvoiceException] 
         * @param {boolean} [createPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingInvoiceQueued(id: number, handledInvoiceException?: boolean, createPdf?: boolean, options?: any): AxiosPromise<CarrInvVm> {
            return localVarFp.createBillingInvoiceQueued(id, handledInvoiceException, createPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create the PDF invoice image for the requested invoice
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPdfInvoice(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.createPdfInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPdfInvoiceQueued(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.createPdfInvoiceQueued(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a request to the queue to create a new invoice.  The web request will return immediately and the crete will be queued and processed out of band.
         * @param {CarrInvVm} [carrInvVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueued(carrInvVm?: CarrInvVm, options?: any): AxiosPromise<QueuedInvoiceCreationResponse> {
            return localVarFp.createQueued(carrInvVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the Carrier Invoice for the Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierInvoiceById(id: number, options?: any): AxiosPromise<CarrInvVm> {
            return localVarFp.getCarrierInvoiceById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageWithData(id: number, imageId: number, options?: any): AxiosPromise<CarrierInvoiceImagesVm> {
            return localVarFp.getImageWithData(id, imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} id 
         * @param {string} imageId 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageWithDataFromObject(id: number, imageId: string, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: any): AxiosPromise<CarrierInvoiceImagesVm> {
            return localVarFp.getImageWithDataFromObject(id, imageId, carrierInvoiceImagesVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all the images associated with an invoice with out the byte arrays
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesForInvoice(id: number, options?: any): AxiosPromise<Array<CarrierInvoiceImagesVm>> {
            return localVarFp.getImagesForInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This is meant for large statement / parcel invoices that have over 20 line items.
         * @param {InitiateMultiPartInvoiceCreationRequest} [initiateMultiPartInvoiceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateMultiPartInvoiceCreation(initiateMultiPartInvoiceCreationRequest?: InitiateMultiPartInvoiceCreationRequest, options?: any): AxiosPromise<InitiateMultiPartInvoiceCreationResponse> {
            return localVarFp.initiateMultiPartInvoiceCreation(initiateMultiPartInvoiceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicePartRequest} [invoicePartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiPartInvoiceCreation(invoicePartRequest?: InvoicePartRequest, options?: any): AxiosPromise<InvoicePartResponse> {
            return localVarFp.multiPartInvoiceCreation(invoicePartRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CarrInvApi - object-oriented interface
 * @export
 * @class CarrInvApi
 * @extends {BaseAPI}
 */
export class CarrInvApi extends BaseAPI {
    /**
     * 
     * @param {AbortMultiPartInvoiceCreationRequest} [abortMultiPartInvoiceCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public abortMultiPartInvoiceCreation(abortMultiPartInvoiceCreationRequest?: AbortMultiPartInvoiceCreationRequest, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).abortMultiPartInvoiceCreation(abortMultiPartInvoiceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds an image to the Carrier Invoice
     * @param {number} id 
     * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public addImage(id: number, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).addImage(id, carrierInvoiceImagesVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceCreationStatusRequest} [invoiceCreationStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public apiCarrInvCheckQueuedInvoiceCreationStatePost(invoiceCreationStatusRequest?: InvoiceCreationStatusRequest, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).apiCarrInvCheckQueuedInvoiceCreationStatePost(invoiceCreationStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public apiCarrInvIdReAuditQueuedPost(id: number, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).apiCarrInvIdReAuditQueuedPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the specific image with the byte array
     * @param {number} id 
     * @param {number} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public carrInvDisconnectImage(id: number, imageId: number, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).carrInvDisconnectImage(id, imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteMultiPartInvoiceCreationRequest} [completeMultiPartInvoiceCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public completeMultiPartInvoiceCreation(completeMultiPartInvoiceCreationRequest?: CompleteMultiPartInvoiceCreationRequest, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).completeMultiPartInvoiceCreation(completeMultiPartInvoiceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new Carrier Invoice
     * @param {CarrInvVm} [carrInvVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public create(carrInvVm?: CarrInvVm, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).create(carrInvVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new Billing invoice for the base invoice
     * @param {number} id 
     * @param {boolean} [handledInvoiceException] 
     * @param {boolean} [createPdf] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public createBillingInvoice(id: number, handledInvoiceException?: boolean, createPdf?: boolean, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).createBillingInvoice(id, handledInvoiceException, createPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new Billing invoice for the base invoice
     * @param {number} id 
     * @param {boolean} [handledInvoiceException] 
     * @param {boolean} [createPdf] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public createBillingInvoiceQueued(id: number, handledInvoiceException?: boolean, createPdf?: boolean, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).createBillingInvoiceQueued(id, handledInvoiceException, createPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create the PDF invoice image for the requested invoice
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public createPdfInvoice(id: number, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).createPdfInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public createPdfInvoiceQueued(id: number, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).createPdfInvoiceQueued(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a request to the queue to create a new invoice.  The web request will return immediately and the crete will be queued and processed out of band.
     * @param {CarrInvVm} [carrInvVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public createQueued(carrInvVm?: CarrInvVm, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).createQueued(carrInvVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the Carrier Invoice for the Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public getCarrierInvoiceById(id: number, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).getCarrierInvoiceById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the specific image with the byte array
     * @param {number} id 
     * @param {number} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public getImageWithData(id: number, imageId: number, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).getImageWithData(id, imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the specific image with the byte array
     * @param {number} id 
     * @param {string} imageId 
     * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public getImageWithDataFromObject(id: number, imageId: string, carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).getImageWithDataFromObject(id, imageId, carrierInvoiceImagesVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all the images associated with an invoice with out the byte arrays
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public getImagesForInvoice(id: number, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).getImagesForInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This is meant for large statement / parcel invoices that have over 20 line items.
     * @param {InitiateMultiPartInvoiceCreationRequest} [initiateMultiPartInvoiceCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public initiateMultiPartInvoiceCreation(initiateMultiPartInvoiceCreationRequest?: InitiateMultiPartInvoiceCreationRequest, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).initiateMultiPartInvoiceCreation(initiateMultiPartInvoiceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicePartRequest} [invoicePartRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrInvApi
     */
    public multiPartInvoiceCreation(invoicePartRequest?: InvoicePartRequest, options?: AxiosRequestConfig) {
        return CarrInvApiFp(this.configuration).multiPartInvoiceCreation(invoicePartRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CarrierApi - axios parameter creator
 * @export
 */
export const CarrierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} scac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByScac: async (scac: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scac' is not null or undefined
            assertParamExists('getByScac', 'scac', scac)
            const localVarPath = `/api/Carrier/scac/{scac}`
                .replace(`{${"scac"}}`, encodeURIComponent(String(scac)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarrierApi - functional programming interface
 * @export
 */
export const CarrierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarrierApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} scac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByScac(scac: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierMinimalVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByScac(scac, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CarrierApi - factory interface
 * @export
 */
export const CarrierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarrierApiFp(configuration)
    return {
        /**
         * 
         * @param {string} scac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByScac(scac: string, options?: any): AxiosPromise<CarrierMinimalVm> {
            return localVarFp.getByScac(scac, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CarrierApi - object-oriented interface
 * @export
 * @class CarrierApi
 * @extends {BaseAPI}
 */
export class CarrierApi extends BaseAPI {
    /**
     * 
     * @param {string} scac 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    public getByScac(scac: string, options?: AxiosRequestConfig) {
        return CarrierApiFp(this.configuration).getByScac(scac, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustPayApi - axios parameter creator
 * @export
 */
export const CustPayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the list of customer pay rules for a specific Bill To
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustPayByBillToIdById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustPayByBillToIdById', 'id', id)
            const localVarPath = `/api/CustPay/btid/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the full list of customer pay rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustPay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or Update a customer pay rule set
         * @param {CustPaySetupVm} [custPaySetupVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsert: async (custPaySetupVm?: CustPaySetupVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustPay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(custPaySetupVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustPayApi - functional programming interface
 * @export
 */
export const CustPayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustPayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the list of customer pay rules for a specific Bill To
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustPayByBillToIdById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustPaySetupVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustPayByBillToIdById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the full list of customer pay rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustPaySetupVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or Update a customer pay rule set
         * @param {CustPaySetupVm} [custPaySetupVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsert(custPaySetupVm?: CustPaySetupVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustPaySetupVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsert(custPaySetupVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustPayApi - factory interface
 * @export
 */
export const CustPayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustPayApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the list of customer pay rules for a specific Bill To
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustPayByBillToIdById(id: string, options?: any): AxiosPromise<Array<CustPaySetupVm>> {
            return localVarFp.getCustPayByBillToIdById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the full list of customer pay rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList(options?: any): AxiosPromise<Array<CustPaySetupVm>> {
            return localVarFp.getList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or Update a customer pay rule set
         * @param {CustPaySetupVm} [custPaySetupVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsert(custPaySetupVm?: CustPaySetupVm, options?: any): AxiosPromise<CustPaySetupVm> {
            return localVarFp.upsert(custPaySetupVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustPayApi - object-oriented interface
 * @export
 * @class CustPayApi
 * @extends {BaseAPI}
 */
export class CustPayApi extends BaseAPI {
    /**
     * 
     * @summary Returns the list of customer pay rules for a specific Bill To
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustPayApi
     */
    public getCustPayByBillToIdById(id: string, options?: AxiosRequestConfig) {
        return CustPayApiFp(this.configuration).getCustPayByBillToIdById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the full list of customer pay rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustPayApi
     */
    public getList(options?: AxiosRequestConfig) {
        return CustPayApiFp(this.configuration).getList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or Update a customer pay rule set
     * @param {CustPaySetupVm} [custPaySetupVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustPayApi
     */
    public upsert(custPaySetupVm?: CustPaySetupVm, options?: AxiosRequestConfig) {
        return CustPayApiFp(this.configuration).upsert(custPaySetupVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerInvoiceApi - axios parameter creator
 * @export
 */
export const CustomerInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Takes a list of customers and creates the batches for customer approval
         * @param {CreateReceivableBatchesForCustomersVm} [createReceivableBatchesForCustomersVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReceivableBatchesForCustomers: async (createReceivableBatchesForCustomersVm?: CreateReceivableBatchesForCustomersVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustomerInvoice/CreateReceivableBatchesForCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReceivableBatchesForCustomersVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerInvoiceApi - functional programming interface
 * @export
 */
export const CustomerInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Takes a list of customers and creates the batches for customer approval
         * @param {CreateReceivableBatchesForCustomersVm} [createReceivableBatchesForCustomersVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReceivableBatchesForCustomers(createReceivableBatchesForCustomersVm?: CreateReceivableBatchesForCustomersVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReceivableBatchesForCustomers(createReceivableBatchesForCustomersVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerInvoiceApi - factory interface
 * @export
 */
export const CustomerInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerInvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Takes a list of customers and creates the batches for customer approval
         * @param {CreateReceivableBatchesForCustomersVm} [createReceivableBatchesForCustomersVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReceivableBatchesForCustomers(createReceivableBatchesForCustomersVm?: CreateReceivableBatchesForCustomersVm, options?: any): AxiosPromise<void> {
            return localVarFp.createReceivableBatchesForCustomers(createReceivableBatchesForCustomersVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerInvoiceApi - object-oriented interface
 * @export
 * @class CustomerInvoiceApi
 * @extends {BaseAPI}
 */
export class CustomerInvoiceApi extends BaseAPI {
    /**
     * 
     * @summary Takes a list of customers and creates the batches for customer approval
     * @param {CreateReceivableBatchesForCustomersVm} [createReceivableBatchesForCustomersVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceApi
     */
    public createReceivableBatchesForCustomers(createReceivableBatchesForCustomersVm?: CreateReceivableBatchesForCustomersVm, options?: AxiosRequestConfig) {
        return CustomerInvoiceApiFp(this.configuration).createReceivableBatchesForCustomers(createReceivableBatchesForCustomersVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the projected request date for pending invoices in an Audit Ok state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgedInvoiceSummary: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/AgedInvoiceSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the count of shipments and the dollar amount for a quick high level view of where things are.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentCountByStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/ShipmentCountByStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the projected request date for pending invoices in an Audit Ok state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgedInvoiceSummary(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgedInvoiceSummaryVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgedInvoiceSummary(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the count of shipments and the dollar amount for a quick high level view of where things are.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentCountByStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShipmentCountByStatusVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentCountByStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the projected request date for pending invoices in an Audit Ok state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgedInvoiceSummary(options?: any): AxiosPromise<Array<AgedInvoiceSummaryVm>> {
            return localVarFp.getAgedInvoiceSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the count of shipments and the dollar amount for a quick high level view of where things are.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentCountByStatus(options?: any): AxiosPromise<Array<ShipmentCountByStatusVm>> {
            return localVarFp.getShipmentCountByStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @summary Gets the projected request date for pending invoices in an Audit Ok state.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getAgedInvoiceSummary(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getAgedInvoiceSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the count of shipments and the dollar amount for a quick high level view of where things are.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getShipmentCountByStatus(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getShipmentCountByStatus(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataExportApi - axios parameter creator
 * @export
 */
export const DataExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExport: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteExport', 'id', id)
            const localVarPath = `/api/DataExport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the Scheduled and completed data exports for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataExports: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataExport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedule the Export of an invoice research search to a CSV file
         * @param {string} [userJobName] 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceResearchExport: async (userJobName?: string, invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataExport/InvoiceResearchExport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (userJobName !== undefined) {
                localVarQueryParameter['userJobName'] = userJobName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceResearchOptionsVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataExportApi - functional programming interface
 * @export
 */
export const DataExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExport(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataExportsVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExport(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the Scheduled and completed data exports for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataExports(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataExportsVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataExports(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Schedule the Export of an invoice research search to a CSV file
         * @param {string} [userJobName] 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceResearchExport(userJobName?: string, invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataExportsVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceResearchExport(userJobName, invoiceResearchOptionsVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataExportApi - factory interface
 * @export
 */
export const DataExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataExportApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExport(id: number, options?: any): AxiosPromise<Array<DataExportsVm>> {
            return localVarFp.deleteExport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the Scheduled and completed data exports for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataExports(options?: any): AxiosPromise<Array<DataExportsVm>> {
            return localVarFp.getDataExports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedule the Export of an invoice research search to a CSV file
         * @param {string} [userJobName] 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceResearchExport(userJobName?: string, invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: any): AxiosPromise<Array<DataExportsVm>> {
            return localVarFp.invoiceResearchExport(userJobName, invoiceResearchOptionsVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataExportApi - object-oriented interface
 * @export
 * @class DataExportApi
 * @extends {BaseAPI}
 */
export class DataExportApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public deleteExport(id: number, options?: AxiosRequestConfig) {
        return DataExportApiFp(this.configuration).deleteExport(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the Scheduled and completed data exports for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public getDataExports(options?: AxiosRequestConfig) {
        return DataExportApiFp(this.configuration).getDataExports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedule the Export of an invoice research search to a CSV file
     * @param {string} [userJobName] 
     * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public invoiceResearchExport(userJobName?: string, invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: AxiosRequestConfig) {
        return DataExportApiFp(this.configuration).invoiceResearchExport(userJobName, invoiceResearchOptionsVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EmailVm} [emailVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailWithOutAttachments: async (emailVm?: EmailVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EmailVm} [emailVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMailWithOutAttachments(emailVm?: EmailVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMailWithOutAttachments(emailVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * 
         * @param {EmailVm} [emailVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailWithOutAttachments(emailVm?: EmailVm, options?: any): AxiosPromise<void> {
            return localVarFp.sendMailWithOutAttachments(emailVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     * 
     * @param {EmailVm} [emailVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public sendMailWithOutAttachments(emailVm?: EmailVm, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).sendMailWithOutAttachments(emailVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GlCodingApi - axios parameter creator
 * @export
 */
export const GlCodingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GLBulkCodingRequest} [gLBulkCodingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCoding: async (gLBulkCodingRequest?: GLBulkCodingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GlCoding/Bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gLBulkCodingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GlCodingRequest} [glCodingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlCodeForInvoice: async (glCodingRequest?: GlCodingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GlCoding/Invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(glCodingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HopkinsDepartmentVm} [hopkinsDepartmentVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHopkinsDepartment: async (hopkinsDepartmentVm?: HopkinsDepartmentVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GlCoding/DetermineHopkinsDepartment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hopkinsDepartmentVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlCodingApi - functional programming interface
 * @export
 */
export const GlCodingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlCodingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GLBulkCodingRequest} [gLBulkCodingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCoding(gLBulkCodingRequest?: GLBulkCodingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCoding(gLBulkCodingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GlCodingRequest} [glCodingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlCodeForInvoice(glCodingRequest?: GlCodingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlCodeForInvoice(glCodingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {HopkinsDepartmentVm} [hopkinsDepartmentVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postHopkinsDepartment(hopkinsDepartmentVm?: HopkinsDepartmentVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postHopkinsDepartment(hopkinsDepartmentVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GlCodingApi - factory interface
 * @export
 */
export const GlCodingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlCodingApiFp(configuration)
    return {
        /**
         * 
         * @param {GLBulkCodingRequest} [gLBulkCodingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCoding(gLBulkCodingRequest?: GLBulkCodingRequest, options?: any): AxiosPromise<void> {
            return localVarFp.bulkCoding(gLBulkCodingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GlCodingRequest} [glCodingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlCodeForInvoice(glCodingRequest?: GlCodingRequest, options?: any): AxiosPromise<void> {
            return localVarFp.getGlCodeForInvoice(glCodingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HopkinsDepartmentVm} [hopkinsDepartmentVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHopkinsDepartment(hopkinsDepartmentVm?: HopkinsDepartmentVm, options?: any): AxiosPromise<void> {
            return localVarFp.postHopkinsDepartment(hopkinsDepartmentVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlCodingApi - object-oriented interface
 * @export
 * @class GlCodingApi
 * @extends {BaseAPI}
 */
export class GlCodingApi extends BaseAPI {
    /**
     * 
     * @param {GLBulkCodingRequest} [gLBulkCodingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlCodingApi
     */
    public bulkCoding(gLBulkCodingRequest?: GLBulkCodingRequest, options?: AxiosRequestConfig) {
        return GlCodingApiFp(this.configuration).bulkCoding(gLBulkCodingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GlCodingRequest} [glCodingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlCodingApi
     */
    public getGlCodeForInvoice(glCodingRequest?: GlCodingRequest, options?: AxiosRequestConfig) {
        return GlCodingApiFp(this.configuration).getGlCodeForInvoice(glCodingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HopkinsDepartmentVm} [hopkinsDepartmentVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlCodingApi
     */
    public postHopkinsDepartment(hopkinsDepartmentVm?: HopkinsDepartmentVm, options?: AxiosRequestConfig) {
        return GlCodingApiFp(this.configuration).postHopkinsDepartment(hopkinsDepartmentVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
export const HealthCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckApi - functional programming interface
 * @export
 */
export const HealthCheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthCheckApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthCheckApi - factory interface
 * @export
 */
export const HealthCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthCheckApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckGet(options?: any): AxiosPromise<void> {
            return localVarFp.healthCheckGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet(options?: any): AxiosPromise<void> {
            return localVarFp.rootGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
export class HealthCheckApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    public healthCheckGet(options?: AxiosRequestConfig) {
        return HealthCheckApiFp(this.configuration).healthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    public rootGet(options?: AxiosRequestConfig) {
        return HealthCheckApiFp(this.configuration).rootGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImagesApi - axios parameter creator
 * @export
 */
export const ImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes an invoice
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage: async (imageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('deleteImage', 'imageId', imageId)
            const localVarPath = `/api/Images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectImage: async (imageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('disconnectImage', 'imageId', imageId)
            const localVarPath = `/api/Images/{imageId}/Disconnect`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisconnectedImages: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Images/DisconnectedImages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: async (imageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('getImage', 'imageId', imageId)
            const localVarPath = `/api/Images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDisconnectedImage: async (carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Images/DisconnectedImages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carrierInvoiceImagesVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImagesApi - functional programming interface
 * @export
 */
export const ImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes an invoice
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImage(imageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImage(imageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectImage(imageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectImage(imageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDisconnectedImages(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DisconnectedCarrInvImagesVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDisconnectedImages(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImage(imageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierInvoiceImagesVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImage(imageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDisconnectedImage(carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDisconnectedImage(carrierInvoiceImagesVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImagesApi - factory interface
 * @export
 */
export const ImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes an invoice
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage(imageId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectImage(imageId: number, options?: any): AxiosPromise<void> {
            return localVarFp.disconnectImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisconnectedImages(options?: any): AxiosPromise<Array<DisconnectedCarrInvImagesVm>> {
            return localVarFp.getDisconnectedImages(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the specific image with the byte array
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(imageId: number, options?: any): AxiosPromise<CarrierInvoiceImagesVm> {
            return localVarFp.getImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDisconnectedImage(carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: any): AxiosPromise<void> {
            return localVarFp.uploadDisconnectedImage(carrierInvoiceImagesVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
export class ImagesApi extends BaseAPI {
    /**
     * 
     * @summary Deletes an invoice
     * @param {number} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public deleteImage(imageId: number, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).deleteImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the specific image with the byte array
     * @param {number} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public disconnectImage(imageId: number, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).disconnectImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public getDisconnectedImages(options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).getDisconnectedImages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the specific image with the byte array
     * @param {number} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public getImage(imageId: number, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).getImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierInvoiceImagesVm} [carrierInvoiceImagesVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public uploadDisconnectedImage(carrierInvoiceImagesVm?: CarrierInvoiceImagesVm, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).uploadDisconnectedImage(carrierInvoiceImagesVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InvoiceEditApi - axios parameter creator
 * @export
 */
export const InvoiceEditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasicInvInfo: async (type: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getBasicInvInfo', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBasicInvInfo', 'id', id)
            const localVarPath = `/api/InvoiceEdit/{type}/{id}/basicinfo`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailedCharges: async (type: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getDetailedCharges', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetailedCharges', 'id', id)
            const localVarPath = `/api/InvoiceEdit/{type}/{id}/detailedcharges`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages: async (type: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getImages', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImages', 'id', id)
            const localVarPath = `/api/InvoiceEdit/{type}/{id}/images`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferences: async (type: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getReferences', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReferences', 'id', id)
            const localVarPath = `/api/InvoiceEdit/{type}/{id}/references`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new Carrier Invoice
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseInvoice: async (type: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('releaseInvoice', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('releaseInvoice', 'id', id)
            const localVarPath = `/api/InvoiceEdit/{type}/{id}/release`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {InvoiceComment} [invoiceComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment: async (type: string, id: number, invoiceComment?: InvoiceComment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('updateComment', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateComment', 'id', id)
            const localVarPath = `/api/InvoiceEdit/{type}/{id}/comments`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceComment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {ReferenceListVm} [referenceListVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferences: async (type: string, id: number, referenceListVm?: ReferenceListVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('updateReferences', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReferences', 'id', id)
            const localVarPath = `/api/InvoiceEdit/{type}/{id}/references`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referenceListVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceEditApi - functional programming interface
 * @export
 */
export const InvoiceEditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceEditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBasicInvInfo(type: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasicInfoVmGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBasicInvInfo(type, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailedCharges(type: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedChargeListVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailedCharges(type, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImages(type: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageListVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImages(type, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferences(type: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceListVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferences(type, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new Carrier Invoice
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseInvoice(type: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseInvoice(type, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {InvoiceComment} [invoiceComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComment(type: string, id: number, invoiceComment?: InvoiceComment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceComment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComment(type, id, invoiceComment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {ReferenceListVm} [referenceListVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReferences(type: string, id: number, referenceListVm?: ReferenceListVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceListVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReferences(type, id, referenceListVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvoiceEditApi - factory interface
 * @export
 */
export const InvoiceEditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceEditApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasicInvInfo(type: string, id: number, options?: any): AxiosPromise<BasicInfoVmGetResponse> {
            return localVarFp.getBasicInvInfo(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailedCharges(type: string, id: number, options?: any): AxiosPromise<DetailedChargeListVm> {
            return localVarFp.getDetailedCharges(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages(type: string, id: number, options?: any): AxiosPromise<ImageListVm> {
            return localVarFp.getImages(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferences(type: string, id: number, options?: any): AxiosPromise<ReferenceListVm> {
            return localVarFp.getReferences(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new Carrier Invoice
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseInvoice(type: string, id: number, options?: any): AxiosPromise<void> {
            return localVarFp.releaseInvoice(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {InvoiceComment} [invoiceComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment(type: string, id: number, invoiceComment?: InvoiceComment, options?: any): AxiosPromise<InvoiceComment> {
            return localVarFp.updateComment(type, id, invoiceComment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {ReferenceListVm} [referenceListVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferences(type: string, id: number, referenceListVm?: ReferenceListVm, options?: any): AxiosPromise<ReferenceListVm> {
            return localVarFp.updateReferences(type, id, referenceListVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceEditApi - object-oriented interface
 * @export
 * @class InvoiceEditApi
 * @extends {BaseAPI}
 */
export class InvoiceEditApi extends BaseAPI {
    /**
     * 
     * @param {string} type 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceEditApi
     */
    public getBasicInvInfo(type: string, id: number, options?: AxiosRequestConfig) {
        return InvoiceEditApiFp(this.configuration).getBasicInvInfo(type, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceEditApi
     */
    public getDetailedCharges(type: string, id: number, options?: AxiosRequestConfig) {
        return InvoiceEditApiFp(this.configuration).getDetailedCharges(type, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceEditApi
     */
    public getImages(type: string, id: number, options?: AxiosRequestConfig) {
        return InvoiceEditApiFp(this.configuration).getImages(type, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceEditApi
     */
    public getReferences(type: string, id: number, options?: AxiosRequestConfig) {
        return InvoiceEditApiFp(this.configuration).getReferences(type, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new Carrier Invoice
     * @param {string} type 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceEditApi
     */
    public releaseInvoice(type: string, id: number, options?: AxiosRequestConfig) {
        return InvoiceEditApiFp(this.configuration).releaseInvoice(type, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type 
     * @param {number} id 
     * @param {InvoiceComment} [invoiceComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceEditApi
     */
    public updateComment(type: string, id: number, invoiceComment?: InvoiceComment, options?: AxiosRequestConfig) {
        return InvoiceEditApiFp(this.configuration).updateComment(type, id, invoiceComment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type 
     * @param {number} id 
     * @param {ReferenceListVm} [referenceListVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceEditApi
     */
    public updateReferences(type: string, id: number, referenceListVm?: ReferenceListVm, options?: AxiosRequestConfig) {
        return InvoiceEditApiFp(this.configuration).updateReferences(type, id, referenceListVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InvoiceResearchApi - axios parameter creator
 * @export
 */
export const InvoiceResearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns the values a user has permission to.  There may be options that are not present because the user  does not have access to invoices with those options.
         * @summary Returns the data for filtering invoice searches.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceResearchPopulationData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InvoiceResearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactDataTableServerSideProcessing: async (invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InvoiceResearch/reactdatatable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceResearchOptionsVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchInvoices: async (invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InvoiceResearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceResearchOptionsVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceResearchApi - functional programming interface
 * @export
 */
export const InvoiceResearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceResearchApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns the values a user has permission to.  There may be options that are not present because the user  does not have access to invoices with those options.
         * @summary Returns the data for filtering invoice searches.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceResearchPopulationData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResearchOptionsVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceResearchPopulationData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactDataTableServerSideProcessing(invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResearchListVmPagingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactDataTableServerSideProcessing(invoiceResearchOptionsVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchInvoices(invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrInvMinimalVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchInvoices(invoiceResearchOptionsVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvoiceResearchApi - factory interface
 * @export
 */
export const InvoiceResearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceResearchApiFp(configuration)
    return {
        /**
         * This returns the values a user has permission to.  There may be options that are not present because the user  does not have access to invoices with those options.
         * @summary Returns the data for filtering invoice searches.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceResearchPopulationData(options?: any): AxiosPromise<InvoiceResearchOptionsVm> {
            return localVarFp.getInvoiceResearchPopulationData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactDataTableServerSideProcessing(invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: any): AxiosPromise<InvoiceResearchListVmPagingResponse> {
            return localVarFp.reactDataTableServerSideProcessing(invoiceResearchOptionsVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchInvoices(invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: any): AxiosPromise<Array<CarrInvMinimalVm>> {
            return localVarFp.searchInvoices(invoiceResearchOptionsVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceResearchApi - object-oriented interface
 * @export
 * @class InvoiceResearchApi
 * @extends {BaseAPI}
 */
export class InvoiceResearchApi extends BaseAPI {
    /**
     * This returns the values a user has permission to.  There may be options that are not present because the user  does not have access to invoices with those options.
     * @summary Returns the data for filtering invoice searches.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceResearchApi
     */
    public getInvoiceResearchPopulationData(options?: AxiosRequestConfig) {
        return InvoiceResearchApiFp(this.configuration).getInvoiceResearchPopulationData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceResearchApi
     */
    public reactDataTableServerSideProcessing(invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: AxiosRequestConfig) {
        return InvoiceResearchApiFp(this.configuration).reactDataTableServerSideProcessing(invoiceResearchOptionsVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoiceResearchOptionsVm} [invoiceResearchOptionsVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceResearchApi
     */
    public searchInvoices(invoiceResearchOptionsVm?: InvoiceResearchOptionsVm, options?: AxiosRequestConfig) {
        return InvoiceResearchApiFp(this.configuration).searchInvoices(invoiceResearchOptionsVm, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MetaInformationApi - axios parameter creator
 * @export
 */
export const MetaInformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [carrierId] 
         * @param {string} [invoiceNum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetaInformationIa360reportinglinkGet: async (carrierId?: string, invoiceNum?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MetaInformation/ia360reportinglink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (carrierId !== undefined) {
                localVarQueryParameter['carrierId'] = carrierId;
            }

            if (invoiceNum !== undefined) {
                localVarQueryParameter['invoiceNum'] = invoiceNum;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAscRefCodes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MetaInformation/AscRefCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAuditFailStatuses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MetaInformation/Status/AuditFail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {string} billToId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDataEntryCodes: async (billToId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billToId' is not null or undefined
            assertParamExists('getCustomerDataEntryCodes', 'billToId', billToId)
            const localVarPath = `/api/MetaInformation/CustomerDataEntryCodes/{billToId}`
                .replace(`{${"billToId"}}`, encodeURIComponent(String(billToId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDataEntryCodesForUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MetaInformation/CustomerDataEntryCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetaInformationApi - functional programming interface
 * @export
 */
export const MetaInformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetaInformationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [carrierId] 
         * @param {string} [invoiceNum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetaInformationIa360reportinglinkGet(carrierId?: string, invoiceNum?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetaInformationIa360reportinglinkGet(carrierId, invoiceNum, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAscRefCodes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AscReferenceCodeVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAscRefCodes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableAuditFailStatuses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatusMasterVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableAuditFailStatuses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {string} billToId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDataEntryCodes(billToId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerReferenceCodeVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDataEntryCodes(billToId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDataEntryCodesForUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerReferenceCodeVm>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDataEntryCodesForUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetaInformationApi - factory interface
 * @export
 */
export const MetaInformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetaInformationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [carrierId] 
         * @param {string} [invoiceNum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetaInformationIa360reportinglinkGet(carrierId?: string, invoiceNum?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiMetaInformationIa360reportinglinkGet(carrierId, invoiceNum, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAscRefCodes(options?: any): AxiosPromise<Array<AscReferenceCodeVm>> {
            return localVarFp.getAscRefCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAuditFailStatuses(options?: any): AxiosPromise<Array<StatusMasterVm>> {
            return localVarFp.getAvailableAuditFailStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {string} billToId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDataEntryCodes(billToId: string, options?: any): AxiosPromise<Array<CustomerReferenceCodeVm>> {
            return localVarFp.getCustomerDataEntryCodes(billToId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the codes used for Invoice References.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDataEntryCodesForUser(options?: any): AxiosPromise<Array<CustomerReferenceCodeVm>> {
            return localVarFp.getCustomerDataEntryCodesForUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetaInformationApi - object-oriented interface
 * @export
 * @class MetaInformationApi
 * @extends {BaseAPI}
 */
export class MetaInformationApi extends BaseAPI {
    /**
     * 
     * @param {string} [carrierId] 
     * @param {string} [invoiceNum] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaInformationApi
     */
    public apiMetaInformationIa360reportinglinkGet(carrierId?: string, invoiceNum?: string, options?: AxiosRequestConfig) {
        return MetaInformationApiFp(this.configuration).apiMetaInformationIa360reportinglinkGet(carrierId, invoiceNum, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the codes used for Invoice References.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaInformationApi
     */
    public getAscRefCodes(options?: AxiosRequestConfig) {
        return MetaInformationApiFp(this.configuration).getAscRefCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaInformationApi
     */
    public getAvailableAuditFailStatuses(options?: AxiosRequestConfig) {
        return MetaInformationApiFp(this.configuration).getAvailableAuditFailStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the codes used for Invoice References.
     * @param {string} billToId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaInformationApi
     */
    public getCustomerDataEntryCodes(billToId: string, options?: AxiosRequestConfig) {
        return MetaInformationApiFp(this.configuration).getCustomerDataEntryCodes(billToId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the codes used for Invoice References.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaInformationApi
     */
    public getCustomerDataEntryCodesForUser(options?: AxiosRequestConfig) {
        return MetaInformationApiFp(this.configuration).getCustomerDataEntryCodesForUser(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserConfigApi - axios parameter creator
 * @export
 */
export const UserConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return the user configuration for the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UserConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return the user configuration for any user.  Requires administrator permissions.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConfiguration: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserConfiguration', 'userId', userId)
            const localVarPath = `/api/UserConfig/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves the user configuration for the currently authenticated user
         * @param {UserConfigurationVm} [userConfigurationVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMyConfig: async (userConfigurationVm?: UserConfigurationVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UserConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userConfigurationVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves the user configuration for any user.  Requires administrator permissions.
         * @param {string} userId 
         * @param {UserConfigurationVm} [userConfigurationVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserConfig: async (userId: string, userConfigurationVm?: UserConfigurationVm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('saveUserConfig', 'userId', userId)
            const localVarPath = `/api/UserConfig/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userConfigurationVm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserConfigApi - functional programming interface
 * @export
 */
export const UserConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return the user configuration for the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigurationVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return the user configuration for any user.  Requires administrator permissions.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserConfiguration(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigurationVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserConfiguration(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves the user configuration for the currently authenticated user
         * @param {UserConfigurationVm} [userConfigurationVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMyConfig(userConfigurationVm?: UserConfigurationVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigurationVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMyConfig(userConfigurationVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves the user configuration for any user.  Requires administrator permissions.
         * @param {string} userId 
         * @param {UserConfigurationVm} [userConfigurationVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserConfig(userId: string, userConfigurationVm?: UserConfigurationVm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigurationVm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserConfig(userId, userConfigurationVm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserConfigApi - factory interface
 * @export
 */
export const UserConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Return the user configuration for the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConfig(options?: any): AxiosPromise<UserConfigurationVm> {
            return localVarFp.getMyConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return the user configuration for any user.  Requires administrator permissions.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConfiguration(userId: string, options?: any): AxiosPromise<UserConfigurationVm> {
            return localVarFp.getUserConfiguration(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves the user configuration for the currently authenticated user
         * @param {UserConfigurationVm} [userConfigurationVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMyConfig(userConfigurationVm?: UserConfigurationVm, options?: any): AxiosPromise<UserConfigurationVm> {
            return localVarFp.saveMyConfig(userConfigurationVm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves the user configuration for any user.  Requires administrator permissions.
         * @param {string} userId 
         * @param {UserConfigurationVm} [userConfigurationVm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserConfig(userId: string, userConfigurationVm?: UserConfigurationVm, options?: any): AxiosPromise<UserConfigurationVm> {
            return localVarFp.saveUserConfig(userId, userConfigurationVm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserConfigApi - object-oriented interface
 * @export
 * @class UserConfigApi
 * @extends {BaseAPI}
 */
export class UserConfigApi extends BaseAPI {
    /**
     * 
     * @summary Return the user configuration for the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserConfigApi
     */
    public getMyConfig(options?: AxiosRequestConfig) {
        return UserConfigApiFp(this.configuration).getMyConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return the user configuration for any user.  Requires administrator permissions.
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserConfigApi
     */
    public getUserConfiguration(userId: string, options?: AxiosRequestConfig) {
        return UserConfigApiFp(this.configuration).getUserConfiguration(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves the user configuration for the currently authenticated user
     * @param {UserConfigurationVm} [userConfigurationVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserConfigApi
     */
    public saveMyConfig(userConfigurationVm?: UserConfigurationVm, options?: AxiosRequestConfig) {
        return UserConfigApiFp(this.configuration).saveMyConfig(userConfigurationVm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves the user configuration for any user.  Requires administrator permissions.
     * @param {string} userId 
     * @param {UserConfigurationVm} [userConfigurationVm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserConfigApi
     */
    public saveUserConfig(userId: string, userConfigurationVm?: UserConfigurationVm, options?: AxiosRequestConfig) {
        return UserConfigApiFp(this.configuration).saveUserConfig(userId, userConfigurationVm, options).then((request) => request(this.axios, this.basePath));
    }
}


